<app-loader *ngIf="isLoading"></app-loader>

<div class="d-none d-md-block">
  <div class="row">
    <div class="col-12">
      <div class="mb-3 information topHeading">
        <span title="{{ currentUserData?.name }}">{{ "DASHBOARD.HI" | translate
          }},&nbsp;{{currentUserData?.name|slice:0:25}}! <span
            *ngIf="currentUserData?.name?.length>=25">...</span></span>
      </div>


      <div class="notification-bell" (click)="NotificationsPopup()">
        <img alt="" src="./assets/images/NotbellIcon.svg" class="bell-icon" />
        <span *ngIf="unreadCount > 0" class="translate-middle badge rounded-pill bg-danger all-counts">
          {{ unreadCount > 10 ? '10+' : unreadCount }}
        </span>
      </div>

      <div class="row mb-2">
        <div class="col-12">
          <owl-carousel-o [options]="dashboardOptions" class="w-auto">
            <ng-container class="w-100">
              <ng-template carouselSlide [id]="totalExpired" class="w-100" *ngIf="totalExpired > 0 ">
                <div
                  class="d-maintext w-auto rounded-10 p-3 d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center">
                  <div class="d-flex align-items-center flex-wrap flex-md-nowrap w-auto">
                    <div class="me-md-4 me-0">
                      <span><img class="me-1" src="./assets/images/licenseAlert.svg" alt="">
                      </span>
                    </div>
                    <div>
                      <h5 class="mt-3 mt-md-2 me-1 fw-bold textColorGreenVogue">
                        {{totalExpired}} {{ 'DASHBOARD.ISEXPIRED' | translate }}
                      </h5>
                    </div>
                  </div>
                  <div class="ms-md-3 ms-0 w-auto mt-2">
                    <button class="bg-orgclr submit-btn-renew  renew-btn  right-end mb-2"
                      (click)="isNavigate('VIEW_LICENCE', userId)">
                      {{ 'MANAGEDEVICE.ACTNOW' | translate }}
                    </button>
                  </div>
                </div>
              </ng-template>
            </ng-container>


            <ng-container class="w-100">
              <ng-template carouselSlide [id]="totalExpiringSoon" class="w-100" *ngIf="totalExpiringSoon > 0 ">
                <div
                  class="d-maintext w-auto rounded-10 p-3 d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center">
                  <div class="d-flex align-items-center flex-wrap flex-md-nowrap w-auto">
                    <div class="me-md-4 me-0">
                      <span><img class="me-1" src="./assets/images/licenseAlert.svg" alt="">
                      </span>
                    </div>
                    <div>
                      <h5 class="mt-3 mt-md-2 me-1 fw-bold textColorGreenVogue">
                        {{totalExpiringSoon}} {{ 'DASHBOARD.GOINGTOEXPIRE' | translate }}
                      </h5>
                    </div>
                  </div>
                  <div class="ms-md-3 ms-0 w-auto mt-2">
                    <button class="bg-orgclr submit-btn-renew  renew-btn  right-end mb-2"
                      (click)="isNavigate('VIEW_LICENCE', userId)">
                      {{ 'MANAGEDEVICE.ACTNOW' | translate }}
                    </button>
                  </div>
                </div>
              </ng-template>
            </ng-container>

            <ng-container class="w-100">
              <ng-template carouselSlide [id]="totallicenseFreeCount" class="w-100" *ngIf="totallicenseFreeCount > 0 ">
                <div
                  class="d-maintext w-auto rounded-10 p-3 d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center">
                  <div class="d-flex align-items-center flex-wrap flex-md-nowrap w-auto">
                    <div class="me-md-4 me-0">
                      <span><img class="me-1" src="./assets/images/licenseAlert.svg" alt="">
                      </span>
                    </div>
                    <div>
                      <h5 class="mt-3 mt-md-2 me-1 fw-bold textColorGreenVogue">
                        {{totallicenseFreeCount}} {{ 'DASHBOARD.YOUAREUSING' | translate }}
                      </h5>
                    </div>
                  </div>
                  <div class="ms-md-3 ms-0 w-auto mt-2">
                    <button class="bg-orgclr submit-btn-renew  renew-btn  right-end mb-2"
                      (click)="isNavigate('VIEW_LICENCE', userId)">
                      {{ 'MANAGEDEVICE.ACTNOW' | translate }}
                    </button>
                  </div>
                </div>
              </ng-template>
            </ng-container>


          </owl-carousel-o>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="d-block d-md-none d-lg-none">
  <div class="row">
    <div class="col-12">
      <div class="mb-3 information topHeading">
        <span title="{{ currentUserData?.name }}">{{ "DASHBOARD.HI" | translate
          }},&nbsp;{{currentUserData?.name|slice:0:25}}! <span
            *ngIf="currentUserData?.name?.length>=25">...</span></span>

      </div>
      <div class="row mb-2">
        <div class="col-12">
          <owl-carousel-o [options]="dashboardOptions" class="w-auto">



            <ng-container class="w-100">
              <ng-template carouselSlide [id]="totalExpired" class="w-100" *ngIf="totalExpired > 0 ">
                <div
                  class="dashboard-mobilevie w-auto rounded-10 p-3 d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center">
                  <div class="d-flex align-items-center flex-wrap flex-md-nowrap w-auto">
                    <div class="me-md-4 me-0">
                      <span><img class="me-1" src="./assets/images/licenseAlert.svg" alt="">
                      </span>
                    </div>
                    <div>
                      <h5 class=" ms-1 fw-bold textColorGreenVogue">
                        {{totalExpired}} {{ 'DASHBOARD.ISEXPIRED' | translate }}
                      </h5>
                    </div>
                  </div>
                  <div class="ms-md-3 ms-0 w-auto mt-2">
                    <button class="bg-orgclr submit-btn-renew  renew-btn  right-end mb-2"
                      (click)="isNavigate('VIEW_LICENCE', userId)">
                      {{ 'MANAGEDEVICE.ACTNOW' | translate }}
                    </button>
                  </div>
                </div>
              </ng-template>
            </ng-container>



            <ng-container class="w-100">
              <ng-template carouselSlide [id]="totalExpiringSoon" class="w-100" *ngIf="totalExpiringSoon > 0 ">
                <div
                  class="dashboard-mobileview-expiringsoon w-auto rounded-10 p-3 d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center">
                  <div class="d-flex align-items-center flex-wrap flex-md-nowrap w-auto">
                    <div class="me-md-4 me-0">
                      <span><img class="me-1" src="./assets/images/licenseAlert.svg" alt="">
                      </span>
                    </div>
                    <div>
                      <h5 class="ms-1 mt-2 fw-bold textColorGreenVogue">
                        {{totalExpiringSoon}} {{ 'DASHBOARD.GOINGTOEXPIRE' | translate }}
                      </h5>
                    </div>
                  </div>
                  <div class="ms-md-3">
                    <button class="bg-orgclr submit-btn-renew  renew-btn  right-end mb-2"
                      (click)="isNavigate('VIEW_LICENCE', userId)">
                      {{ 'MANAGEDEVICE.ACTNOW' | translate }}
                    </button>
                  </div>
                </div>
              </ng-template>
            </ng-container>





            <ng-container class="w-100">
              <ng-template carouselSlide [id]="totallicenseFreeCount" class="w-100" *ngIf="totallicenseFreeCount > 0 ">
                <div
                  class="dashboard-mobilevie w-auto rounded-10 p-3 d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center">
                  <div class="d-flex align-items-center flex-wrap flex-md-nowrap w-auto">
                    <div class="me-md-4 me-2 mb-1">
                      <span><img class="me-1" src="./assets/images/licenseAlert.svg" alt="">
                      </span>
                    </div>
                    <div>
                      <h5 class="mt-2 mt-md-1 me-1 fw-bold textColorGreenVogue">
                        {{totallicenseFreeCount}} {{ 'DASHBOARD.YOUAREUSING' | translate }}
                      </h5>
                    </div>
                  </div>
                  <div class="ms-md-3 ms-0 w-auto">
                    <button class="bg-orgclr submit-btn-renew  renew-btn  right-end mb-2"
                      (click)="isNavigate('VIEW_LICENCE', userId)">
                      {{ 'MANAGEDEVICE.ACTNOW' | translate }}
                    </button>
                  </div>
                </div>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="renewPopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered ">
    <ng-container>
      <div
        class="modal-content text-center border-none changeWidthHeight overflow-hidden rounded-25 shadow-lg relative w-100 pointer-events-auto bg-white outline-none">
        <div class="mt-3">
          <img src="./assets/images/not secure.png" alt="" class="mx-auto" />
        </div>
        <h5 class="fw-bold mt-1 mb-2">
          {{ "LICENSESUMMARY.RENEWPOPUP" | translate }}
        </h5>
        <p class="text-sm p-xl-2">
          {{ "LICENSESUMMARY.RENEWDESC" | translate }}
        </p>
        <div class="text-center mb-4 mt-1 d-flex justify-content-center">
          <div class="me-3">
            <button type="button" class="submit-btn bg-orgclr" data-bs-dismiss="modal">
              {{ "LICENSESUMMARY.OK" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div class="overlay p-4 rounded-25" *ngIf="img_blr">
  <div>
    <button class="bg-orgclr text-sm submit-btn buynow" (click)="addDevice()">
      {{ "ADDDEVICE.ADDDEVICE" | translate }}
    </button>
  </div>
</div>

<div class="relative">
  <div class="bg-white text-center mb-3 p-3 rounded-10 relative" *ngIf="devicesList?.length === 0">
    <img [src]="'DASHBOARD.RECORDNOTFOUNDIMG' | translate" width="100%" alt="" class="empty-dashboard-image" />
    <div class="tapToAddDevice">
      <img [src]="'DASHBOARD.NODEVICELOCK' | translate" alt="" class="pencilImg mt-1 mx-4" />
      <div class=" empty-dashboard-text">
        {{ "DASHBOARD.TAPTOADD" | translate }}
      </div>
      <button class="bg-orgclr text-sm submit-btn buynow mt-2 empty-dashboard-button" (click)="addDevice()">
        {{ "ADDDEVICE.ADDDEVICE" | translate }}
      </button>
    </div>
  </div>
</div>

<div class="d-xl-flex gap-3" *ngIf="devicesList&&devicesList.length != 0">
  <div class="col-xl-7 col-12">
    <div class="relative">
      <div class="information" *ngIf="devicesList?.length !=0">
        <span title>{{ "DASHBOARD.TOTALSCOREMESSEGE" | translate }}
        </span>
      </div>
      <div class="me-2 d-flex justify-content-between align-items-center">
        <div class="d-flex">
          <h6 class="textColorGreenVogue" *ngIf="devicesList?.length !=0">
            {{ "DASHBOARD.CUMMULATIVESCOREMESSEGE" | translate }}
          </h6>
        </div>
        <div class="d-flex">
          <div class="userdropdown">

            <ng-select class="bg-transparent custom w-100" [items]=" userResponse" [(ngModel)]="user" bindLabel="name"
              bindValue="id" [clearable]=false [searchable]=false (ngModelChange)="getdashboardDataByuserId($event)">
              <ng-template class="text-truncate custom" ng-label-tmp let-item="item">
                <img height="15" width="15" src="assets/images/Vector 651usericon.svg" />
                <span class="ps-2" title={{item?.name}}>{{ item.name.length > 15 ? item.name.slice(0,15) + "..." :
                  item.name
                  }}</span>
              </ng-template>
              <ng-template class="text-truncate custom" ng-option-tmp let-item="item" let-index="index">
                <span title={{item?.name}}>{{ item.name.length > 15 ? item.name.slice(0,15) + "..." :
                  item.name}}</span>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </div>

    <div class="d-none d-md-block">
      <div class="bg-white p-md-4 p-3 mt-3 rounded-15 ">
        <div
          [ngClass]="securityRecommendations&&securityRecommendations.length != 0?'':'d-flex justify-content-center align-items-center w-100'">
          <div>
            <div class="row">
              <div class="col-md-6">
                <div class="" *ngIf="devicesList?.length != 0">
                  <div class="text-center">
                    <h6 class="textColorGreenVogue-scores  mb-0 me-5">
                      {{ "DASHBOARD.OVERALLSECSCORE" | translate }}
                      <div class="dropdown dashboard-tooltip cursor-pointer">
                        <img src="assets/images/Group 1000007342dashboardinfoicon.svg" alt="" class="me-1" />
                        <div class="dropdown-content" i18n-title>
                          <div class="d-flex flex-column">
                            <div> {{ "SETTINGS.MESSEGES.SECURITYMESSEGE" | translate }}</div>
                          </div>
                        </div>
                      </div>
                    </h6>
                    <div class="d-flex justify-content-center align-items-center mt-3 mb-3 me-5">
                      <div class="guage_outer">
                        <div class="guage_inner">
                          <div class="semi_guage">
                            <div class="guage_fil" [style.background]="securityStatusClr"
                              [ngStyle]="{ 'transform': 'rotate(0deg) translate(0,0) rotate('+security_rot_deg+'deg)' }">
                            </div>
                          </div>
                          <div class="guage_cover">
                            <p><span class="score_text" [style.color]="securityStatusClr">{{ securityScore }}</span><br>
                              <span class="score_out_text"> {{ "DASHBOARD.OUTOF" | translate }}
                                {{securityTotalScore}}</span>
                            </p>
                          </div>
                          <div class="guage_pill">
                            <div class="mt-2"><span class="guage_pill_text" [style.color]="securityStatusClr"><span
                                  class="me-1"><img [src]=securityScoreIcon alt="" /></span> {{securityScoreStatus |
                                translate}}</span></div>

                          </div>
                        </div>
                        <div *ngIf="showUrl" class="w-100 d-flex justify-content-center mt-3 ">
                          <div class="text-sm">

                            <h5
                              class="badge badge-pill status-text-recommendation justify-content-center my-1 ms-1 recommend fw-bold"
                              *ngIf="privacyRecommendations?.length != 0 || privacyScore == 0">
                              {{ securityRecommendations&&securityRecommendations.length }} {{
                              "DASHBOARD.RECOMMENDATIONS"
                              |
                              translate }}
                              <span class="fw-normal"></span>
                            </h5>
                            <h5
                              class=" badge badge-pill excellent-recommendation justify-content-center my-1 ms-2 recommend fw-bold"
                              *ngIf="privacyRecommendations?.length == 1000">
                              {{ "DASHBOARD.DASHBOARDEXCELLENTSCORE" | translate }}
                              <span class="fw-normal"></span>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-1 verticleLine"></div>
              <div class="mt-5 mt-md-0 col-md-5">
                <div class="" *ngIf="devicesList?.length != 0">
                  <div class="text-center">
                    <h6 class="textColorGreenVogue-scores  mb-0 ">
                      {{ "DASHBOARD.OVERALLPRIVSCORE" | translate }}
                      <div class="dropdown dashboard-tooltip cursor-pointer">
                        <img src="assets/images/Group 1000007342dashboardinfoicon.svg" alt="" class="me-1" />
                        <div class="dropdown-content" i18n-title>
                          <div class="d-flex flex-column">
                            <div> {{ "SETTINGS.MESSEGES.PRIVACYMESSEGE" | translate }}</div>
                          </div>
                        </div>
                      </div>
                    </h6>

                    <div class="d-flex justify-content-center align-items-center mt-3 mb-3  ">
                      <div class="guage_outer">
                        <div class="guage_inner">
                          <div class="semi_guage">
                            <div class="guage_fil" [style.background]="privacyStatusClr"
                              [ngStyle]="{ 'transform': 'rotate(0deg) translate(0,0) rotate('+privacy_rot_deg+'deg)' }">
                            </div>
                          </div>
                          <div class="guage_cover">
                            <p><span class="score_text" [style.color]="privacyStatusClr">{{ privacyScore }}</span><br>
                              <span class="score_out_text">{{ "DASHBOARD.OUTOF" | translate }}
                                {{securityTotalScore}}</span>
                            </p>
                          </div>
                          <div class="guage_pill">
                            <div class="mt-2"><span class="guage_pill_text" [style.color]="privacyStatusClr"><span
                                  class="me-1"><img [src]=privacyScoreIcon alt="" /></span> {{privacyScoreStatus |
                                translate}}</span></div>
                          </div>
                        </div>
                        <div *ngIf="showUrl" class="w-100 d-flex justify-content-center mt-3">
                          <div class="text-sm">
                            <h5
                              class=" badge badge-pill status-text-recommendation justify-content-center my-1 ms-2 recommend fw-bold"
                              *ngIf="privacyRecommendations?.length != 0 || privacyScore == 0">
                              {{ privacyRecommendations&&privacyRecommendations.length }} {{ "DASHBOARD.RECOMMENDATIONS"
                              |
                              translate }}
                              <span class="fw-normal"></span>
                            </h5>

                            <h5
                              class=" badge badge-pill excellent-recommendation justify-content-center my-1 ms-2 recommend fw-bold"
                              *ngIf="privacyRecommendations?.length == 1000">
                              {{ "DASHBOARD.DASHBOARDEXCELLENTSCORE" | translate }}
                              <span class="fw-normal"></span>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center  mx-auto" *ngIf="devicesList?.length != 0"
                [ngClass]="(securityRecommendations&&securityRecommendations.length != 0) || (privacyRecommendations&&privacyRecommendations.length !=0)?'':''">
                <button class="submit-btn bg-orgclr py-2 px-4 me-3 add-device shadow-none"
                  *ngIf="privacyScore != 1000 || securityScore != 1000" (click)="isNavigate('VIEW_SCORE', userId)">
                  {{ "MANAGEUSER.VIEWRECOMMENDATION" | translate }}
                </button>
                <div *ngIf="privacyScore == 1000 && securityScore == 1000">
                  <span class="mb-5 badge-pill excellent-recommendation-dashboard  "> {{ "DASHBOARD.NOACTION" |
                    translate
                    }}</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="d-block d-md-none d-lg-none">
      <div class="bg-white p-md-4 p-3 mt-3 rounded-15 ">
        <div
          [ngClass]="securityRecommendations&&securityRecommendations.length != 0?'':'d-flex justify-content-center align-items-center w-100'">
          <div>
            <div class="row">
              <div class="col-md-6">
                <div class="" *ngIf="devicesList?.length != 0">
                  <div class="text-center">
                    <h6 class="textColorGreenVogue-scores  mb-0 me-3">
                      {{ "DASHBOARD.OVERALLSECSCORE" | translate }}
                      <div class="dropdown dashboard-tooltip-mobileview cursor-pointer">
                        <img src="assets/images/Group 1000007342dashboardinfoicon.svg" alt="" class="me-1" />
                        <div class="dropdown-content" i18n-title>
                          <div class="d-flex flex-column">
                            <div> {{ "SETTINGS.MESSEGES.SECURITYMESSEGE" | translate }}</div>
                          </div>
                        </div>
                      </div>
                    </h6>
                    <div class="d-flex justify-content-center align-items-center mt-3 mb-3 me-3">
                      <div class="guage_outer">
                        <div class="guage_inner">
                          <div class="semi_guage">
                            <div class="guage_fil" [style.background]="securityStatusClr"
                              [ngStyle]="{ 'transform': 'rotate(0deg) translate(0,0) rotate('+security_rot_deg+'deg)' }">
                            </div>
                          </div>
                          <div class="guage_cover">
                            <p><span class="score_text" [style.color]="securityStatusClr">{{ securityScore }}</span><br>
                              <span class="score_out_text">{{ "DASHBOARD.OUTOF" | translate }}
                                {{securityTotalScore}}</span>
                            </p>
                          </div>
                          <div class="guage_pill">
                            <div class="mt-2"><span class="guage_pill_text" [style.color]="securityStatusClr"><span
                                  class="me-1"><img [src]=securityScoreIcon alt="" /></span> {{securityScoreStatus |
                                translate}}</span></div>

                          </div>
                        </div>
                        <div *ngIf="showUrl" class="w-100 d-flex justify-content-center mt-3 ">
                          <div class="text-sm">

                            <h5
                              class="badge badge-pill status-text-recommendation justify-content-center my-1 ms-1 recommend fw-bold"
                              *ngIf="privacyRecommendations?.length != 0 || privacyScore == 0">
                              {{ securityRecommendations&&securityRecommendations.length }} {{
                              "DASHBOARD.RECOMMENDATIONS"
                              |
                              translate }}
                              <span class="fw-normal"></span>
                            </h5>
                            <h5
                              class=" badge badge-pill excellent-recommendation justify-content-center my-1 ms-2 recommend fw-bold"
                              *ngIf="privacyRecommendations?.length == 1000">
                              {{ "DASHBOARD.DASHBOARDEXCELLENTSCORE" | translate }}
                              <span class="fw-normal"></span>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-4  col-md-5">
                <div class="" *ngIf="devicesList?.length != 0">
                  <div class="text-center">
                    <h6 class="textColorGreenVogue-scores  mb-0 ">
                      {{ "DASHBOARD.OVERALLPRIVSCORE" | translate }}
                      <div class="dropdown dashboard-tooltip-mobileview cursor-pointer">
                        <img src="assets/images/Group 1000007342dashboardinfoicon.svg" alt="" class="me-1" />
                        <div class="dropdown-content" i18n-title>
                          <div class="d-flex flex-column">
                            <div> {{ "SETTINGS.MESSEGES.PRIVACYMESSEGE" | translate }}</div>
                          </div>
                        </div>
                      </div>
                    </h6>

                    <div class="d-flex justify-content-center align-items-center mt-3 mb-3  ">
                      <div class="guage_outer">
                        <div class="guage_inner">
                          <div class="semi_guage">
                            <div class="guage_fil" [style.background]="privacyStatusClr"
                              [ngStyle]="{ 'transform': 'rotate(0deg) translate(0,0) rotate('+privacy_rot_deg+'deg)' }">
                            </div>
                          </div>
                          <div class="guage_cover">
                            <p><span class="score_text" [style.color]="privacyStatusClr">{{ privacyScore }}</span><br>
                              <span class="score_out_text">{{ "DASHBOARD.OUTOF" | translate }}
                                {{securityTotalScore}}</span>
                            </p>
                          </div>
                          <div class="guage_pill">
                            <div class="mt-2"><span class="guage_pill_text" [style.color]="privacyStatusClr"><span
                                  class="me-1"><img [src]=privacyScoreIcon alt="" /></span> {{privacyScoreStatus |
                                translate}}</span></div>
                          </div>
                        </div>
                        <div *ngIf="showUrl" class="w-100 d-flex justify-content-center mt-3">
                          <div class="text-sm">
                            <h5
                              class=" badge badge-pill status-text-recommendation justify-content-center my-1 ms-2 recommend fw-bold"
                              *ngIf="privacyRecommendations?.length != 0 || privacyScore == 0">
                              {{ privacyRecommendations&&privacyRecommendations.length }} {{ "DASHBOARD.RECOMMENDATIONS"
                              |
                              translate }}
                              <span class="fw-normal"></span>
                            </h5>

                            <h5
                              class=" badge badge-pill excellent-recommendation justify-content-center my-1 ms-2 recommend fw-bold"
                              *ngIf="privacyRecommendations?.length == 1000">
                              {{ "DASHBOARD.DASHBOARDEXCELLENTSCORE" | translate }}
                              <span class="fw-normal"></span>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center  mx-auto" *ngIf="devicesList?.length != 0"
                [ngClass]="(securityRecommendations&&securityRecommendations.length != 0) || (privacyRecommendations&&privacyRecommendations.length !=0)?'':''">
                <button class="submit-btn bg-orgclr py-2 px-4 me-3 add-device shadow-none"
                  *ngIf="privacyScore != 1000 || securityScore != 1000" (click)="isNavigate('VIEW_SCORE', userId)">
                  {{ "MANAGEUSER.VIEWRECOMMENDATION" | translate }}
                </button>
                <div *ngIf="privacyScore == 1000 && securityScore == 1000">
                  <span class="mb-5 badge-pill excellent-recommendation-dashboard  "> {{ "DASHBOARD.NOACTION" |
                    translate
                    }}</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


    <div class="mt-4 mb-1">
      <span class="scores">{{ "SIDEBAR.INSIGHTS" | translate }}</span>
      <div class="mt-3"><button [ngClass]="selectedReport != 'screentime'?'buttonsClick' : 'buttonsClickfocus'"
          (click)="selectReport('screentime');getScreentimeData(userId);resetGraphData()">{{
          "SETTINGS.SCREENTIME" |
          translate
          }}</button>

        <button *ngIf="showParentalTab" type="menu" class="ms-2"
          [ngClass]="selectedReport != 'parental'?'buttonsClick' : 'buttonsClickfocus'"
          (click)="selectReport('parental');getRestrictedHitsPerDevice(userId)">{{ "SETTINGS.PARENTALCONTROL" |
          translate
          }} </button>
        <button type="menu" class="ms-2" [ngClass]="selectedReport != 'threat'?'buttonsClick' : 'buttonsClickfocus'"
          (click)="selectReport('threat');areaChart(deviceId)">{{
          "PARENTALREPORTS.THREATS" |
          translate
          }}</button>
        <button *ngIf="showParentalTab" type="menu" class="ms-2"
          [ngClass]="selectedReport != 'youtube'?'buttonsClick' : 'buttonsClickfocus'"
          (click)="selectReport('youtube');youtubeUsageChartData(userId)">{{ "SETTINGS.YOUTUBESUPERVISION" |
          translate
          }}</button>
        <button type="menu" class="ms-2" *ngIf="showAntiTrackerReports"
          (click)="selectReport('antiTracker');getUserWiseAntiTrackerReport(userId)"
          [ngClass]="selectedReport != 'antiTracker'?'buttonsClick' : 'buttonsClickfocus'">{{ "DASHBOARD.ANTITRACKER"
          |
          translate
          }}</button>
      </div>
    </div>



    <!-- Threat report chart starts here-->
    <div class="mt-2 bg-white p-3 rounded-15" *ngIf=" (threatsdetected > 0) && selectedReport === 'threat'">
      <div class="col-sm-12" style="position: relative;">

        <div class="d-none d-md-block">
          <div class="border-bottom negative_padding-threat ">
            <div class="ms-4 text_20_600 ">
              <span class="ms-2">
                <img class="me-0 threat-detect-image" src="./assets/images/threatImage.svg" alt="">
              </span>
              <span class="me-5 threat-detect-insights ">
                {{ "DASHBOARD.THREATDETECT" | translate }}
              </span>
            </div>
            <div class="mb-3 ms-4 text_20_600">
              <span class="chartTitle" [ngClass]="totalCount >10 ? 'ms-2' : 'ms-2'">
                {{ totalCount }}
              </span>
              <span class="last7-dashboard ">
                {{ "DASHBOARD.INLAST7DAYS" | translate }}
              </span>
            </div>
            <div>
              <a routerLink="/home/reports"><span class="insights-link">{{
                  "DASHBOARD.VIEWDETAILEDINSIGHT" | translate
                  }} <img style="width: 8px;" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a>
            </div>
          </div>
        </div>


        <div class="d-block d-md-none d-lg-none">
          <div class="border-bottom negative_padding-threat ">
            <div class="ms-4 text_20_600 ">
              <span class="ms-2">
                <img class="me-0 threat-detect-image" src="./assets/images/threatImage.svg" alt="">
              </span>
              <span class="me-5 threat-detect-insights ">
                {{ "DASHBOARD.THREATDETECT" | translate }}
              </span>
            </div>
            <div class="mb-3 ms-4 text_20_600">
              <span class="chartTitle" [ngClass]="totalCount >10 ? 'ms-2' : 'ms-2'">
                {{ totalCount }}
              </span>
              <span class="last7-dashboard ">
                {{ "DASHBOARD.INLAST7DAYS" | translate }}
              </span>
            </div>
            <div>
              <a routerLink="/home/reports"><span class="insights-link-mobileview">{{
                  "DASHBOARD.VIEWDETAILEDINSIGHT" | translate
                  }} <img style="width: 8px;" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a>
            </div>
          </div>
        </div>




        <div class="row-reverse-dashboard">
          <div class="mt-2 flex-container" *ngFor="let item of deviceNameListMap | keyvalue">
            <div class="mb-1 me-2 " [title]="item.key">
              <span class=" me-1 mt-1"><img class="flex-container" src="{{item.value}}" alt=""></span>
              <span class="mb-1 me-1"> {{ isString(item.key) ? item.key.slice(0, 7) : '' }}...</span>
            </div>
          </div>
        </div>

        <div class="chart-container mt-0">
          <canvas id="threatReportChart" height="168"></canvas>
        </div>
      </div>
    </div>

    <div class="mt-2 bg-white p-3 border-radius-12" *ngIf="(threatsdetected < 1) && selectedReport === 'threat'">
      <div class="col-sm-12" style="position: relative;">
        <div class="border-bottom negative_padding">
          <div class=" mt-2 ms-4 text_20_600 ">
            <span class="ms-2">
              <img class="me-0 threat-detect-image" src="./assets/images/threatImage.svg" alt="">
            </span>
            <span class="me-5 threat-detect-insights ">
              {{ "DASHBOARD.THREATDETECT" | translate }}
            </span>
          </div>
          <div class="mt-4 pt-2 ms-4 text_20_600 ">
          </div>

          <div class="d-none d-md-block">
            <div>
              <a routerLink="/home/reports"><span class="insights-link">{{
                  "DASHBOARD.VIEWDETAILEDINSIGHT" | translate
                  }} <img style="width: 8px;" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a>
            </div>
          </div>

          <div class="d-block d-md-none d-lg-none">
            <div>
              <a routerLink="/home/reports"><span class="insights-link-mobileview">{{
                  "DASHBOARD.VIEWDETAILEDINSIGHT" | translate
                  }} <img style="width: 8px;" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a>
            </div>
          </div>


        </div>
        <div class="col-sm-12 p-1 relative text-center">
          <div class="mt-4">
            <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
          </div>
          <div class="mt-2">
            <span class="empty-report-text">
              {{"DASHBOARD.NOREPORTSFOUND" | translate}}
            </span>
          </div>
        </div>
      </div>
    </div>
    <!--  Screentime Report  -->
    <div class="mt-2 bg-white border-radius-12 p-3" *ngIf="selectedReport === 'screentime'">
      <!-- empty Report -->
      <div class="col-sm-12" style="position: relative;" *ngIf="noOfItemToShowScreen < 1 && screenToggle">

        <div class="d-none d-md-block">
          <div class="border-bottom negative_padding">
            <div class=" mt-2 ms-4 text_20_600 ">
              <span style="font-weight: 400;font-size: 18px;"><span><img src="./assets/images/TimeclockTime.svg"
                    alt=""></span>{{"DASHBOARD.YESTERDAYSCREENTIME" | translate}}</span>
            </div>
            <div class="mt-4 pt-2 ms-4 text_20_600 ">
            </div>
            <div>
              <a routerLink="/home/reports"><span class="insights-link">{{
                  "DASHBOARD.VIEWDETAILEDINSIGHT" | translate
                  }} <img style="width: 8px;" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a>
            </div>
          </div>
        </div>


        <div class="d-block d-md-none d-lg-none">
          <div class="border-bottom negative_padding">
            <div class="ms-4 text_20_600 ">
              <span style="font-weight: 400;font-size: 18px;"><span><img src="./assets/images/TimeclockTime.svg"
                    alt=""></span>{{"DASHBOARD.YESTERDAYSCREENTIME" | translate}}</span>
            </div>
            <div class="mt-4 pt-2 ms-4 text_20_600 ">
            </div>
            <div>
              <a routerLink="/home/reports"><span class="insights-link-mobileview">{{
                  "DASHBOARD.VIEWDETAILEDINSIGHT" | translate
                  }} <img style="width: 8px;" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a>
            </div>
          </div>
        </div>


        <div class="col-sm-12 p-1 relative text-center">
          <div class="mt-4">
            <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
          </div>
          <div class="mt-2">
            <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
          </div>
        </div>
      </div>
      <!--Screentime Toggle state image -->
      <div class="col-sm-12 relative text-center" *ngIf="noOfItemToShowScreen < 1 && !screenToggle">
        <div class="mt-5 mb-1">
          <span><img src="./assets/images/enableToggle.svg" alt=""></span>
        </div>
        <div class="mt-2">
          <span class="empty-report-text">{{ "DASHBOARD.ENABLESCREENTIME" | translate }}</span>
        </div>
        <div class="mb-4 pb-2">
          <span> {{ "DASHBOARD.ENABLEONINDDEVICE" | translate }} </span>
        </div>
      </div>
      <!-- Actual Report starts here -->
      <div class="col-sm-12 relative" *ngIf="noOfItemToShowScreen > 0">
        <div class="border-bottom negative_padding">
          <div class=" mt-2 ms-4 text_20_600 ">
            <span style="font-weight: 400;font-size: 18px;"><span><img src="./assets/images/TimeclockTime.svg"
                  alt=""></span>{{"DASHBOARD.YESTERDAYSCREENTIME" | translate}}</span>
          </div>
          <div class="mt-0 mb-3 ms-3 text_20_600 ">
            <span class="ms-2">{{ totalHours + "h " + totalMin + "m" }} </span>
          </div>
          <div class="cursor-pointer"><a routerLink="/home/reports"><span
                style="position:absolute;top: 4px;right: 24px;color: #F16522; text-decoration: underline;font-weight: 600;">{{
                "DASHBOARD.VIEWDETAILEDINSIGHT" | translate
                }} <img class="ms-1" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a></div>
        </div>
        <div class="relative">
          <div style="position: absolute;top: 8px; right: 32px;">
            <span class="me-2"><img class="me-1 pb-1" src="./assets/images/RecommdLine.svg"
                alt="">{{"DASHBOARD.RECOMMEND" | translate}} {{ "( 4h 0m)" }} </span>
            <span class="me-1"><img class="me-1 pb-1" src="./assets/images/underLimitIcon.svg"
                alt="">{{"PARENTALREPORTS.UNDERUTILIZED" | translate}} </span>
            <span class="me-1"><img class="me-1 pb-1" src="./assets/images/overLimitIcon.svg"
                alt="">{{"PARENTALREPORTS.OVERUTILIZED" | translate}} </span>
          </div>
        </div>
        <div class="chart-container mt-4 pt-2">
          <canvas id="deviceWiseScreentime" width="400" height="168"></canvas>
        </div>
      </div>
    </div>
    <!-- Smart Paretal report will come here -->
    <div class="mt-2 bg-white p-3 border-radius-12"
      *ngIf="productKeyType === 'MOBILE' && selectedReport === 'parental'">
      <!-- Smart Parental Report Empty State -->
      <div class="col-sm-12" style="position: relative;" *ngIf="paretalToggle && parentalGraph">

        <div class="d-none d-md-block">
          <div class="border-bottom negative_padding">
            <div class=" mt-2 ms-4 text_20_600 ">
              <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                    src="./assets/images/hitIcon.svg" alt=""></span>{{ "PARENTALREPORTS.ATTEMPTSTORESTRICTED" |
                translate
                }}</span>
            </div>
            <div class="mt-4 pt-2 ms-4 text_20_600 ">
            </div>
            <div>
              <a routerLink="/home/reports"><span class="insights-link">{{
                  "DASHBOARD.VIEWDETAILEDINSIGHT" | translate
                  }} <img style="width: 8px;" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a>
            </div>
          </div>
        </div>

        <div class="d-block d-md-none d-lg-none">
          <div class="border-bottom negative_padding">
            <div class=" mt-2 ms-4 text_20_600 ">
              <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                    src="./assets/images/hitIcon.svg" alt=""></span>{{ "PARENTALREPORTS.ATTEMPTSTORESTRICTED" |
                translate
                }}</span>
            </div>
            <div class="mt-4 pt-2 ms-4 text_20_600 ">
            </div>
            <div>
              <a routerLink="/home/reports"><span class="insights-link-mobileview">{{
                  "DASHBOARD.VIEWDETAILEDINSIGHT" | translate
                  }} <img style="width: 8px;" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a>
            </div>
          </div>
        </div>




        <div class="col-sm-12 p-1 relative text-center">
          <div class="mt-4">
            <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
          </div>
          <div class="mt-2">
            <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
          </div>
        </div>
      </div>
      <!-- Smart Parental Report Toggle State -->
      <div class="col-sm-12 relative text-center" *ngIf="!paretalToggle && parentalGraph">
        <div class="mt-5 mb-1">
          <span><img src="./assets/images/enableToggle.svg" alt=""></span>
        </div>
        <div class="mt-2">
          <span class="empty-report-text">{{ "DASHBOARD.ENABLEPARENTALSETTINGS" | translate }}</span>
        </div>
        <div class="mb-4 pb-2">
          <span> {{ "DASHBOARD.ENABLEONINDDEVICE" | translate }} </span>
        </div>
      </div>
      <!-- Actual Smart Parental Report Chart -->
      <div class="col-sm-12 relative" *ngIf="noOfParentalData > 0 && !parentalGraph">
        <div class="border-bottom negative_padding">
          <div class=" mt-2 ms-4 text_20_600 ">
            <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                  src="./assets/images/hitIcon.svg" alt=""></span>{{ "PARENTALREPORTS.ATTEMPTSTORESTRICTED" |
              translate
              }}</span>
          </div>
          <div class="mt-0 mb-3 ms-4 text_20_600 ">
            <span> {{ totalHitCounts }}</span>
            <span class="ms-1">{{ "PARENTALREPORTS.ATTEMPTS" | translate }}<span class="ms-1"
                style="font-weight: 400;font-size: 12px;">{{
                "DASHBOARD.INLAST7DAYS" | translate }}</span> </span>
          </div>


          <div class="d-none d-md-block">
            <div>
              <a routerLink="/home/reports"><span
                  style="position:absolute;top: 4px;right: 24px;color: #F16522; text-decoration: underline;font-weight: 600;">{{
                  "DASHBOARD.VIEWDETAILEDINSIGHT" | translate
                  }} <img class="ms-1" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a>
            </div>
          </div>

          <div class="d-block d-md-none d-lg-none">
            <div>
              <a routerLink="/home/reports"><span
                  style="position:absolute;top: 22px;right: 2px;color: #F16522; text-decoration: underline;font-weight: 600;">{{
                  "DASHBOARD.VIEWDETAILEDINSIGHT" | translate
                  }} <img class="ms-1" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a>
            </div>
          </div>




        </div>
        <div class="relative">
          <div style="position: absolute;top: 8px; right: 32px;">
            <span class="me-1"><img class="me-1" src="./assets/images/webRedIcon.svg" alt="">{{
              "PARENTALREPORTS.WEBSITE" | translate }} </span>
            <span><img class="me-1" src="./assets/images/yellowRectIcon.svg" alt="">{{ "PARENTALREPORTS.APP" |
              translate}}</span>
          </div>
        </div>
        <div class="chart-container mt-4 pt-2 me-3">
          <canvas id="deviceWiseParental" width="400" height="168"></canvas>
        </div>
      </div>
    </div>
    <!-- Youtube Report starts here -->
    <div class="mt-2 bg-white p-3" style="border-radius: 12px;" *ngIf="selectedReport === 'youtube'">
      <!-- Actual Report-->
      <ng-container *ngIf="isYoutubeUsageChart">
        <div class="col-sm-12 relative">
          <div class="border-bottom negative_padding">
            <div class=" mt-2 ms-4 text_20_600 ">
              <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                    src="./assets/images/youtubeIcon.svg" alt=""></span>{{ "DASHBOARD.ATTEMPTOYOUTUBECAT" |
                translate
                }}</span>
            </div>
            <div class="mt-0 mb-3 ms-4 text_20_600 ">
              <span> {{ totalTimeSpent }}</span>
              <span class="ms-1">{{ "PARENTALREPORTS.ATTEMPTS" | translate }}<span class="ms-1"
                  style="font-weight: 400;font-size: 12px;">{{
                  "DASHBOARD.INLAST7DAYS" | translate }}</span> </span>
            </div>


            <div class="d-none d-md-block">
              <div>
                <a routerLink="/home/reports"><span
                    style="position:absolute;top: 4px;right: 24px;color: #F16522; text-decoration: underline;font-weight: 600;">{{
                    "MANAGEUSER.VIEWDETAILS" | translate
                    }} <img class="ms-1" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a>
              </div>
            </div>

            <div class="d-block d-md-none d-lg-none">
              <div><a routerLink="/home/reports"><span
                    style="position:absolute;top: 22px;right: 2px;color: #F16522; text-decoration: underline;font-weight: 600;">{{
                    "MANAGEUSER.VIEWDETAILS" | translate
                    }} <img class="ms-1" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a>
              </div>
            </div>


          </div>
          <div class="chart-container mt-4 pt-2 me-3">
            <canvas id="youtubeUsageGraph" width="400" height="168"></canvas>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!isYoutubeUsageChart && !youtubeToggle">
        <!-- Empty Report -->
        <div class="col-sm-12" style="position: relative;">
          <div class="border-bottom negative_padding">
            <div class=" mt-2 ms-4 text_20_600 ">
              <span style="font-weight: 400;font-size: 18px;"><span class="me-1"><img class="pb-1"
                    src="./assets/images/youtubeIcon.svg" alt=""></span>{{ "DASHBOARD.ATTEMPTOYOUTUBECAT" |
                translate
                }}</span>
            </div>
            <div class="mt-4 pt-2 ms-4 text_20_600 ">
            </div>
            <div>
              <a routerLink="/home/reports"><span class="insights-link">{{
                  "DASHBOARD.VIEWDETAILEDINSIGHT" | translate
                  }} <img style="width: 8px;" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a>
            </div>
          </div>
          <div class="col-sm-12 p-1 relative text-center">
            <div class="mt-4">
              <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
            </div>
            <div class="mt-2">
              <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!isYoutubeUsageChart && youtubeToggle">
        <!-- Youtube Report Toggle State -->
        <div class="col-sm-12 relative text-center">
          <div class="mt-5 pt-0 mb-1">
            <span><img src="./assets/images/enableToggle.svg" alt=""></span>
          </div>
          <div class="mt-2">
            <span class="empty-report-text">{{ "DASHBOARD.ENABLEYOUTUBE" | translate }}</span>
          </div>
          <div class="mb-4 pb-2">
            <span> {{ "DASHBOARD.ENABLEONINDDEVICE" | translate }} </span>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="mt-2 bg-white p-3 border-radius-12" *ngIf="selectedReport === 'antiTracker'">
      <!--Anti Tracker empty Report -->
      <div class="col-sm-12" style="position: relative;" *ngIf="noOfDevices < 1">


        <div class="d-none d-md-block">
          <div class="border-bottom negative_padding">
            <div class=" mt-2 ms-4 text_20_600 ">
              <span class="font-18 font-weight-400"><span><img src="./assets/images/Blocked_eye_icon.svg"
                    alt=""></span>{{"REPORTS.TRACKERSBLOCKED" | translate}}</span>
            </div>
            <div class="mt-4 pt-2 ms-4 text_20_600 ">
            </div>
            <div>
              <a routerLink="/home/reports"><span class="insights-link">{{
                  "DASHBOARD.VIEWDETAILEDINSIGHT" | translate
                  }} <img style="width: 8px;" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a>
            </div>
          </div>
        </div>



        <div class="d-block d-md-none d-lg-none">
          <div class="border-bottom negative_padding">
            <div class=" mt-2 ms-4 text_20_600 ">
              <span class="font-18 font-weight-400"><span><img src="./assets/images/Blocked_eye_icon.svg"
                    alt=""></span>{{"REPORTS.TRACKERSBLOCKED" | translate}}</span>
            </div>
            <div class="mt-4 pt-2 ms-4 text_20_600 ">
            </div>
            <div>
              <a routerLink="/home/reports"><span class="insights-link-mobileview">{{
                  "DASHBOARD.VIEWDETAILEDINSIGHT" | translate
                  }} <img style="width: 8px;" src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a>
            </div>
          </div>
        </div>


        <div class="col-sm-12 p-1 relative text-center">
          <div class="mt-4">
            <span><img src="./assets/images/screenEmptyReport.svg" alt=""></span>
          </div>
          <div class="mt-2">
            <span class="empty-report-text">{{"DASHBOARD.NOREPORTSFOUND" | translate}}</span>
          </div>
        </div>
      </div>
      <!--Anti Tracker Actual Report starts here -->
      <div class="col-sm-12 relative" *ngIf="noOfDevices > 0">

        <div class="d-none d-md-block">
          <div class="border-bottom negative_padding">
            <div class=" mt-2 ms-4 text_20_600 ">
              <span class="font-18 font-weight-400"><span><img src="./assets/images/Blocked_eye_icon.svg"
                    alt=""></span>{{"REPORTS.TRACKERSBLOCKED" | translate}}</span>
            </div>
            <div class="mt-0 mb-3 ms-3 text_20_600 ">
              <span class="ms-2">{{antiTrackersBlockedCnt}} </span>
              <span>{{"REPORTS.BLOCKED" | translate}} </span>
              <span class="last7-dashboard ">
                {{ "DASHBOARD.INLAST7DAYS" | translate }}
              </span>
            </div>
            <div class="cursor-pointer"><a routerLink="/home/reports"><span
                  class="insights-link">{{"DASHBOARD.VIEWDETAILEDINSIGHT" | translate }} <img class="ms-1"
                    src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a></div>
          </div>
        </div>




        <div class="d-block d-md-none d-lg-none">
          <div class="border-bottom negative_padding">
            <div class=" mt-2 ms-4 text_20_600 ">
              <span class="font-18 font-weight-400"><span><img src="./assets/images/Blocked_eye_icon.svg"
                    alt=""></span>{{"REPORTS.TRACKERSBLOCKED" | translate}}</span>
            </div>
            <div class="mt-0 mb-3 ms-3 text_20_600 ">
              <span class="ms-2">{{antiTrackersBlockedCnt}} </span>
              <span>{{"REPORTS.BLOCKED" | translate}} </span>
              <span class="last7-dashboard ">
                {{ "DASHBOARD.INLAST7DAYS" | translate }}
              </span>
            </div>
            <div class="cursor-pointer"><a routerLink="/home/reports"><span
                  class="insights-link-mobileview">{{"DASHBOARD.VIEWDETAILEDINSIGHT" | translate }} <img class="ms-1"
                    src="./assets/images/insightbar.svg" alt="" class="mx-auto"></span></a></div>
          </div>
        </div>


        <div class="float-end">

        </div>
        <div class="chart-container mt-4 pt-2">
          <canvas id="dashboardAntiTrackerReport" width="400" height="168"></canvas>
        </div>
      </div>
    </div>
    <div class=" p-3 my-3  rounded-25 text-white  bg-white " [ngClass]="screenWidth<850?'':'heightFixed'"
      *ngIf="productKeyType === 'SYSTEM'">
      <div class="col-sm-12">
        <h5 class="fw-bold mt-2 ms-2 mb-4 textColorGreenVogue">
          {{ "DASHBOARD.DEVICEFEATURES" | translate }}
        </h5>
        <owl-carousel-o [options]="customOptions">
          <ng-container class="">
            <ng-template carouselSlide>
              <div class="devicefeature-card cursor-pointer" (click)="sendCommandScore(getDeviceId, 'SCORE')">
                <div class="mb-2">
                  <img [src]="'DASHBOARD.SCOREMAIN' | translate" alt="" />
                </div>
                <div data-toggle="tooltip" class="textColorGreenVogue fw-bold" i18n-title
                  title="{{ 'MANAGEDEVICE.SCORE' | translate }}">
                  {{ "MANAGEDEVICE.SCORE" | translate }}
                </div>
              </div>
            </ng-template>
          </ng-container>
        </owl-carousel-o>
      </div>
    </div>


  </div>
  <div class="col-xl-5 col-12">
    <ng-container *ngIf="!notification">
      <div class="rfd">
        <div class=" ms-1 information">
          <span title>{{ "DASHBOARD.INFORMATION" | translate }}
          </span>
        </div>

        <div class="ms-2">
          <span class="me-1">
            <button class="cursor-pointer campaignBtn " (click)="getclick('ALL')"
              [disabled]=" (!getAllCampaignsData ||getAllCampaignsData.length === 0)"
              [ngClass]=" getAllCampaignsData&&getAllCampaignsData.length ==0?'buttonsClickfocus opacity-50':(!top3)?'buttonsClick':'buttonsClickfocus'">
              <span style=" font-size: 15px;">{{ "MANAGEDEVICE.ALL" | translate }}</span>
            </button>
          </span>

          <span class="ms-2 me-1">
            <button class="filterClass cursor-pointer campaignBtn mb-2" (click)="getclick('ANNOUNCEMENT')"
              [disabled]=" (!getAllCampaignsData ||getAllCampaignsData.length === 0)"
              [ngClass]=" getAllCampaignsData&&getAllCampaignsData.length ==0?'buttonsClick opacity-50 ':(!isAnnouncemnt)?'buttonsClick':'buttonsClickfocus'"
              [title]="announcement">
              <img
                [src]="(!getAllCampaignsData ||getAllCampaignsData.length === 0)?'./assets/images/announcement.svg':(isAnnouncemnt )?'./assets/images/announcement_white.svg':'./assets/images/announcementANNOUNCEMENTLABEL.svg'"
                alt="" class="width-25 height-25" />
            </button>
          </span>



          <span class="ms-2 me-1">
            <button class=" filterClass campaignBtn cursor-pointer " (click)="getclick('BLOG')"
              [disabled]=" (!getAllCampaignsData ||getAllCampaignsData.length === 0)"
              [ngClass]=" getAllCampaignsData&&getAllCampaignsData.length ==0?'buttonsClick opacity-50 ':(!isblog )?'buttonsClick': 'buttonsClickfocus'"
              [title]="blogs">
              <img
                [src]="(!getAllCampaignsData ||getAllCampaignsData.length === 0)?'./assets/images/Blogsligh.svg':(isblog )?'./assets/images/blog_white_1.svg':'./assets/images/BlogsBLOGLABEL.svg'"
                alt="" class="width-25 height-25" />
            </button>
          </span>

          <span class="ms-2 me-1">
            <button class=" filterClass campaignBtn cursor-pointer " (click)="getclick('OFFER')"
              [disabled]=" (!getAllCampaignsData ||getAllCampaignsData.length === 0)"
              [ngClass]=" getAllCampaignsData&&getAllCampaignsData.length ==0?'buttonsClick opacity-50 ':(!isOffer )?'buttonsClick':'buttonsClickfocus'"
              [title]="offers">
              <img
                [src]="(!getAllCampaignsData ||getAllCampaignsData.length === 0)?'./assets/images/Bookmark.svg':(isOffer )?'./assets/images/Bookmarkoffericonwhite.svg':'./assets/images/BookmarkOFFERLABEL.svg'"
                alt="" class="width-25 height-25" />
            </button>
          </span>

          <span class="ms-2 me-1">
            <button class=" filterClass campaignBtn cursor-pointer " (click)="getclick('SURVEY')"
              [disabled]=" (!getAllCampaignsData ||getAllCampaignsData.length === 0)"
              [ngClass]=" getAllCampaignsData&&getAllCampaignsData.length ==0?'buttonsClick opacity-50':(!issurvey )?'buttonsClick':'buttonsClickfocus'"
              [title]="survey">
              <img
                [src]="(!getAllCampaignsData ||getAllCampaignsData.length === 0)?'./assets/images/Surveylight.svg':(issurvey )?'./assets/images/List Clipboardsurveyiconwhite.svg':'./assets/images/Component 4SURVEYLABEL.svg'"
                alt="" class="width-25 height-25" />
            </button>
          </span>
        </div>
      </div>

      <div class="d-none d-md-block">
        <div *ngIf="isAnnouncemnt">
          <div class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
            *ngFor="let slide of getMyAnnounce;let i = index" [ngClass]="screenWidth<850?'':'heightFixed'" id="check">
            <ng-container class="w-100">
              <div class="relative ms-1 mt-2">

                <span *ngIf="slide?.campaignType !='SYSTEM'">
                  <img *ngIf="slide.imagePromotional" [src]="slide.imagePromotional" alt=""
                    class="img-fluid  rounded-10 object-fit-contain" style="width: 97px;height: 52px;">
                </span>
                <span *ngIf=" slide?.campaignType =='SYSTEM'">
                  <img *ngIf="slide.imagePromotional" [src]="slide.imagePromotional"
                    [ngClass]="(!slide.ctaLabel)?'desktop-blog-img':'desktop-blog-img-small'" alt=""
                    class="img-fluid mt-1 rounded-10 object-fit-contain" />
                </span>
                <span *ngIf="slide?.campaignType =='MOBILE'">
                  <img *ngIf="!slide?.imagePromotional" [src]="'IMAGES.ANNOUCEMENTEMPTY' | translate" alt=""
                    class="img-fluid rounded-10 object-fit-contain" style="width: 97px;height: 52px;" />
                </span>

                <div class=" w-100 d-flex mt-2 ms-1">
                  <div class="w-100">
                    <div class=" mb-2 mt-1 text-truncate textColorGreenVogue-title" [title]="slide?.title">
                      {{ slide?.title|slice:0:80}}
                    </div>
                    <div class="mt-2d-flex w-100 gap-3 justify-content-between mb-4">
                      <p class="mt-2 ellipsisText" [title]="slide?.description">
                        {{ slide?.description}}
                      </p>
                    </div>
                    <div>
                      <button type="button" *ngIf="slide.ctaLabel" class="bg-orgclr submit-btn shadow-none"
                        (click)="goToLink(slide?.ctaTargetLink)"
                        style="position:absolute; max-width: 9rem; top: 151px; left: 5px;">
                        {{slide.ctaLabel?slide.ctaLabel : "DASHBOARD.BUYNOW" | translate }}
                      </button>
                    </div>
                  </div>
                  <span class="q-form-white-submits text-xs ms-5" style="position:absolute;right: 15px;top: 10px;">
                    <img style="width: 35px;height: 35px;" alt=""
                      src="./assets/images/announcementannouncementcard.svg" />
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="d-block d-md-none d-lg-none">
        <div *ngIf="isAnnouncemnt">
          <div class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
            *ngFor="let slide of getMyAnnounce;let i = index" [ngClass]="screenWidth<850?'':'heightFixed'" id="check">
            <ng-container class="w-100">
              <div class="relative ms-1 mt-2">

                <span *ngIf="slide?.campaignType !='SYSTEM'">
                  <img *ngIf="slide.imagePromotional" [src]="slide.imagePromotional" alt=""
                    class="img-fluid  rounded-10 object-fit-contain" style="width: 97px;height: 52px;">
                </span>
                <span *ngIf=" slide?.campaignType =='SYSTEM'">
                  <img *ngIf="slide.imagePromotional" [src]="slide.imagePromotional"
                    [ngClass]="(!slide.ctaLabel)?'desktop-blog-img':'desktop-blog-img-small'" alt=""
                    class="img-fluid mt-1 rounded-10 object-fit-contain" />
                </span>
                <span *ngIf="slide?.campaignType =='MOBILE'">
                  <img *ngIf="!slide?.imagePromotional" [src]="'IMAGES.ANNOUCEMENTEMPTY' | translate" alt=""
                    class="img-fluid rounded-10 object-fit-contain" style="width: 97px;height: 52px;" />
                </span>

                <div class=" w-100 d-flex mt-2 ms-1">
                  <div class="d-none d-md-block">
                    <div class="w-100">
                      <div class=" mb-2 mt-1 text-truncate textColorGreenVogue-title" [title]="slide?.title">
                        {{ slide?.title|slice:0:80}}
                      </div>
                      <div class="mt-2d-flex w-100 gap-3 justify-content-between mb-5">
                        <p class="mt-2 ellipsisText" [title]="slide?.description">
                          {{ slide?.description}}
                        </p>
                      </div>
                      <div>
                        <button type="button" *ngIf="slide.ctaLabel" class="bg-orgclr submit-btn shadow-none"
                          (click)="goToLink(slide?.ctaTargetLink)"
                          style="position:absolute; max-width: 9rem; top: 141px; left: 5px;">
                          {{slide.ctaLabel?slide.ctaLabel : "DASHBOARD.BUYNOW" | translate }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="d-block d-md-none d-lg-none">
                    <div class="w-100">
                      <div class=" mb-2 mt-1 text-truncate textColorGreenVogue-title" [title]="slide?.title">
                        {{ slide?.title|slice:0:80}}
                      </div>
                      <div class="mt-2d-flex w-100 gap-3 justify-content-between mb-5">
                        <p class="mt-2 ellipsisText" [title]="slide?.description">
                          {{ slide?.description}}
                        </p>
                      </div>
                      <div>
                        <button type="button" *ngIf="slide.ctaLabel" class="bg-orgclr submit-btn shadow-none"
                          (click)="goToLink(slide?.ctaTargetLink)"
                          style="position:absolute; max-width: 9rem; top: 141px; left: 5px;">
                          {{slide.ctaLabel?slide.ctaLabel : "DASHBOARD.BUYNOW" | translate }}
                        </button>
                      </div>
                    </div>
                  </div>


                  <span class="q-form-white-submits text-xs ms-5" style="position:absolute;right: 15px;top: 10px;">
                    <img style="width: 35px;height: 35px;" alt=""
                      src="./assets/images/announcementannouncementcard.svg" />
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div *ngIf="(isblog) && (!isAnnouncemnt)">
        <div class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
          *ngFor="let slide of getMyBlog;let i = index" [ngClass]="screenWidth<850?'':'heightFixed'" id="check">
          <ng-container class="w-100">
            <div class="relative ms-1">
              <span *ngIf="slide?.campaignType !='SYSTEM'">
                <img *ngIf="slide.imagePromotional" [src]="slide.imagePromotional" alt=""
                  class="img-fluid  rounded-10 mt-1 object-fit-contain" style="width: 97px;height: 52px;">
              </span>
              <span *ngIf=" (slide?.templateType=='NEWS_INFO_BLOG') &&(slide?.campaignType =='SYSTEM')">
                <img *ngIf="slide.imagePromotional" [src]="slide.imagePromotional"
                  [ngClass]="(slide?.campaignType =='SYSTEM') && (!slide.ctaLabel)?'desktop-blog-img':'desktop-blog-img-small'"
                  alt="" class="img-fluid mt-1 rounded-10 object-fit-contain" />
              </span>

              <div class=" w-100 d-flex mt-3 ms-1 ">
                <div class="d-none d-md-block">
                  <div class="w-100">
                    <h5 class="fw-bold mb-2 text-truncate textColorGreenVogue-title" [title]="slide?.title">
                      {{ slide?.title|slice:0:75}}...
                    </h5>
                    <div class="mt-2d-flex w-100 gap-3 justify-content-between mb-4">
                      <p class="mt-2 ellipsisText" [title]="slide?.description">
                        {{ slide?.description}}
                      </p>
                    </div>

                    <div>
                      <button type="button" class="bg-orgclr submit-btn shadow-none" *ngIf="slide.ctaLabel"
                        (click)="goToLink(slide?.ctaTargetLink)"
                        style="position:absolute; max-width: 9rem; top: 160px; left: 6px;">
                        {{slide.ctaLabel?slide.ctaLabel : "DASHBOARD.BUYNOW" | translate }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="d-block d-md-none d-lg-none">
                  <div class="w-100">
                    <h5 class="fw-bold mb-2 text-truncate textColorGreenVogue-title" [title]="slide?.title">
                      {{ slide?.title|slice:0:75}}...
                    </h5>
                    <div class="mt-2d-flex w-100 gap-3 justify-content-between mb-5">
                      <p class="mt-2 ellipsisText" [title]="slide?.description">
                        {{ slide?.description}}
                      </p>
                    </div>

                    <div>
                      <button type="button" class="bg-orgclr submit-btn shadow-none" *ngIf="slide.ctaLabel"
                        (click)="goToLink(slide?.ctaTargetLink)"
                        style="position:absolute; max-width: 9rem; top: 142px; left: 6px;">
                        {{slide.ctaLabel?slide.ctaLabel : "DASHBOARD.BUYNOW" | translate }}
                      </button>
                    </div>
                  </div>
                </div>


                <span class="q-form-white-submits text-xs ms-5" style="position:absolute;right: 15px;top: 10px;">
                  <img style="width: 32px;height: 32px;" alt="" src="./assets/images/Notenewblogs.png" />
                </span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div *ngIf="(isOffer) ">
        <div class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
          *ngFor="let slide of getMyOffer;let i = index" [ngClass]="screenWidth<850?'':'heightFixed'" id="check">
          <ng-container class="w-100">
            <div class="relative ms-1">
              <div class="w-100 d-flex mt-1">
                <img *ngIf="slide.offerImage" [src]="slide.offerImage" alt=""
                  class="img-fluid  rounded-10 object-fit-contain mt-2 ms-1" style="width: 100px;height: 58px;">
                <img *ngIf="!slide.offerImage&&!slide.nooffer&&!slide.noSurvey&&!slide.title"
                  [src]="'IMAGES.OFFERPICNOTPRESENT' | translate" alt=""
                  class="img-fluid rounded-10 object-fit-contain mt-2 ms-1" style="width: 100px;height: 58px;">
                <img *ngIf="!slide.offerImage&&slide.noSurvey" [src]="'IMAGES.NOSURVEYEMPTYIMG' | translate" alt=""
                  class="img-fluid offerImageOffer  rounded-10 object-fit-contain mt-2 ms-1">
                <img *ngIf="!slide.offerImage&&slide.title&&!slide.noSurvey" [src]="'IMAGES.SURVEYIMG' | translate"
                  alt="" class="img-fluid offerImageOffer  rounded-10 object-fit-contain mt-2 ms-1">
                <div class=" mx-4 gap-2 mt-3">
                  <span class="gray-clr fw-bold-offers  textLineThrough">
                    {{(slide.productPrice&&slide.discount)?'Rs'+((slide.productPrice/(100-slide.discount))*100):''}}
                  </span>
                  <div class="org-clr fw-bold highlightedTextSize">{{slide.productPrice?('Rs'+slide.productPrice):''}}
                  </div>
                </div>
              </div>
              <div class=" w-100 d-flex mt-2 ms-1 ">
                <div class="d-none d-md-block">
                  <div class="w-100">
                    <h5 class="fw-bold mb-2 text-truncate textColorGreenVogue-title"
                      [title]="slide.offerHeadLine? slide.offerHeadLine:slide.title">
                      {{ slide.offerHeadLine? slide.offerHeadLine:slide.title|slice:0:60}}
                    </h5>
                    <div class="mt-2d-flex w-100 gap-3 justify-content-between mb-4">
                      <p class="mt-2 ellipsisText"
                        [title]="slide.offerDescription?slide.offerDescription:slide.description">
                        {{ slide?.offerDescription }}
                      </p>
                    </div>
                    <div>
                      <button type="button" class="bg-orgclr submit-btn shadow-none"
                        (click)="goToLink(slide?.ctaTargetLink)"
                        style="position:absolute; max-width: 9rem; top: 156px; left: 8px;">
                        {{slide.ctaLabel?slide.ctaLabel : "DASHBOARD.BUYNOW" | translate }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="d-block d-md-none d-lg-none">
                  <div class="w-100">
                    <h5 class="fw-bold mb-2 text-truncate textColorGreenVogue-title"
                      [title]="slide.offerHeadLine? slide.offerHeadLine:slide.title">
                      {{ slide.offerHeadLine? slide.offerHeadLine:slide.title|slice:0:60}}
                    </h5>
                    <div class="mt-2d-flex w-100 gap-3 justify-content-between mb-5">
                      <p class="mt-2 ellipsisText"
                        [title]="slide.offerDescription?slide.offerDescription:slide.description">
                        {{ slide?.offerDescription }}
                      </p>
                    </div>
                    <div>
                      <button type="button" class="bg-orgclr submit-btn shadow-none"
                        (click)="goToLink(slide?.ctaTargetLink)"
                        style="position:absolute; max-width: 9rem; top: 138px; left: 8px;">
                        {{slide.ctaLabel?slide.ctaLabel : "DASHBOARD.BUYNOW" | translate }}
                      </button>
                    </div>
                  </div>
                </div>


                <span class="q-form-white-submits text-xs ms-5" style="position:absolute;right: 15px;top: 10px;">
                  <img style="width: 30px;height: 30px;" alt="" src="./assets/images/Rectangle 96offersnewcards.svg" />
                </span>
              </div>
            </div>
          </ng-container>
        </div>
        <!-- </div> -->
      </div>
      <div class="d-none d-md-block">
        <div *ngIf="issurvey">
          <div class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
            *ngFor="let slide of getMySurvey;let i = index" [ngClass]="screenWidth<850?'':'heightFixed'" id="check">
            <ng-container class="w-100">
              <div class="relative ms-1">
                <img src="./assets/images/Survery & Feedback (1) 1.svg" alt="" class="rounded-10 mt-1"
                  style="width: 97px;height: 52px;" />
                <div class=" w-100 d-flex mt-3 ms-1 ">

                  <div class="w-100">
                    <h5 class="fw-bold mb-2 text-truncate textColorGreenVogue-title" [title]="slide?.title">
                      {{ slide?.title|slice:0:80}}...
                    </h5>
                    <div class="mt-2d-flex w-100 gap-3 justify-content-between mb-4">
                      <p class="mt-2 ellipsisText" [title]="slide?.description" *ngIf="slide?.description">
                        {{ slide?.description}}
                      </p>
                    </div>
                    <div>
                      <button type="button" class="bg-orgclr submit-btn shadow-none mt-3"
                        style="position:absolute; max-width: 9rem; top: 145px; left: 6px;"
                        (click)="goToLink(slide?.ctaTargetLink)">
                        {{slide.ctaLabel?slide.ctaLabel : "DASHBOARD.BUYNOW" | translate }}
                      </button>
                    </div>
                  </div>
                  <span class="q-form-white-submits text-xs ms-5" style="position:absolute;right: 15px;top: 10px;">
                    <img style="width: 35px;height: 35px;" alt="" src="./assets/images/Component 7surveycard.svg" />
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>


      <div class="d-block d-md-none d-lg-none">
        <div *ngIf="issurvey">
          <div class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
            *ngFor="let slide of getMySurvey;let i = index" [ngClass]="screenWidth<850?'':'heightFixed'" id="check">
            <ng-container class="w-100">
              <div class="relative ms-1">
                <img src="./assets/images/Survery & Feedback (1) 1.svg" alt="" class="rounded-10 mt-1"
                  style="width: 97px;height: 52px;" />
                <div class=" w-100 d-flex mt-3 ms-1 ">

                  <div class="w-100">
                    <h5 class="fw-bold mb-2 text-truncate textColorGreenVogue-title" [title]="slide?.title">
                      {{ slide?.title|slice:0:80}}...
                    </h5>
                    <div class="mt-2d-flex w-100 gap-3 justify-content-between mb-5">
                      <p class="mt-2 ellipsisText" [title]="slide?.description" *ngIf="slide?.description">
                        {{ slide?.description}}
                      </p>
                    </div>
                    <div>
                      <button type="button" class="bg-orgclr submit-btn shadow-none "
                        style="position:absolute; max-width: 9rem; top: 145px; left: 6px;"
                        (click)="goToLink(slide?.ctaTargetLink)">
                        {{slide.ctaLabel?slide.ctaLabel : "DASHBOARD.BUYNOW" | translate }}
                      </button>
                    </div>
                  </div>
                  <span class="q-form-white-submits text-xs ms-5" style="position:absolute;right: 15px;top: 10px;">
                    <img style="width: 35px;height: 35px;" alt="" src="./assets/images/Component 7surveycard.svg" />
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>


      <div class="d-none d-md-block">
        <div *ngIf="(top3 )" [ngClass]=" getAllCampaignsData&&getAllCampaignsData.length <=3?'mt-3':'scroller mt-2'">
          <div class="p-3 ms-2 my-3 mt-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
            *ngFor="let slide of getAllCampaignsData;let i = index" [ngClass]="screenWidth<850?'':'heightFixed-alltab'"
            id="check">
            <ng-container class="w-100">
              <div class="relative ms-1">
                <div class="w-100 d-flex mt-2">
                  <div *ngIf=" slide?.templateType=='ANNOUNCEMENT'">
                    <span *ngIf="slide?.campaignType !='SYSTEM'">
                      <img *ngIf="slide.imagePromotional" [src]="slide.imagePromotional" alt=""
                        class="img-fluid  rounded-10 object-fit-contain" style="width: 97px;height: 52px;">
                    </span>
                    <img *ngIf="!slide?.imagePromotional" [src]="'IMAGES.ANNOUCEMENTEMPTY' | translate" alt=""
                      class="img-fluid rounded-10 object-fit-contain" style="width: 97px;height: 52px;" />
                    <span *ngIf=" (slide?.templateType=='ANNOUNCEMENT') &&(slide?.campaignType =='SYSTEM')">
                      <img *ngIf="slide.imagePromotional" [src]="slide.imagePromotional"
                        [ngClass]="(slide?.campaignType =='SYSTEM') && (!slide.ctaLabel)?'desktop-blog-img':'desktop-blog-img-small'"
                        alt="" class="img-fluid mt-1 rounded-10 object-fit-contain" />
                    </span>

                  </div>
                  <div *ngIf=" slide?.templateType=='OFFER_NOTIFICATION'">
                    <img *ngIf="slide.offerImage" [src]="slide.offerImage" alt=""
                      class="img-fluid  rounded-10 object-fit-contain  mt-1 ms-2" style="width: 100px;height: 58px;">
                    <img *ngIf="!slide.offerImage&&!slide.nooffer&&!slide.noSurvey&&!slide.title"
                      [src]="'IMAGES.OFFERPICNOTPRESENT' | translate" alt=""
                      class="img-fluid rounded-10 object-fit-contain  mt-1 ms-2" style="width: 100px;height: 58px;">
                    <img *ngIf="!slide.offerImage&&slide.noSurvey" [src]="'IMAGES.NOSURVEYEMPTYIMG' | translate" alt=""
                      class="img-fluid offerImageOffer  rounded-10 object-fit-contain  mt-1 ms-2">
                    <img *ngIf="!slide.offerImage&&slide.title&&!slide.noSurvey" [src]="'IMAGES.SURVEYIMG' | translate"
                      alt="" class="img-fluid offerImageOffer  rounded-10 object-fit-contain  mt-1 ms-2">
                  </div>
                  <div *ngIf=" (slide?.templateType=='NEWS_INFO_BLOG') &&(slide?.campaignType =='MOBILE')">
                    <img [src]="slide?.imagePromotional" alt="" class="img-fluid rounded-10 object-fit-contain"
                      style="width: 97px;height: 52px;" />
                  </div>
                  <span *ngIf=" (slide?.templateType=='NEWS_INFO_BLOG') &&(slide?.campaignType =='SYSTEM')">
                    <img *ngIf="slide.imagePromotional" [src]="slide.imagePromotional"
                      [ngClass]="(slide?.campaignType =='SYSTEM') && (!slide.ctaLabel)?'desktop-blog-img':'desktop-blog-img-small'"
                      alt="" class="img-fluid mt-1 rounded-10 object-fit-contain" />
                  </span>

                  <div *ngIf=" slide?.templateType=='SURVEY_FEEDBACK'">
                    <img src="./assets/images/Survery & Feedback (1) 1.svg" alt="" class="surveyimage" />
                  </div>
                  <div class=" mx-4 gap-2 mt-2">
                    <span class="gray-clr fw-bold-offers  textLineThrough">
                      {{(slide.productPrice&&slide.discount)?'Rs'+((slide.productPrice/(100-slide.discount))*100):''}}
                    </span>
                    <div class="org-clr fw-bold highlightedTextSize">{{slide.productPrice?('Rs'+slide.productPrice):''}}
                    </div>
                  </div>
                </div>
                <div class="w-100 d-flex mt-2 ms-1">
                  <div class="w-100" *ngIf=" slide?.templateType !='OFFER_NOTIFICATION'">
                    <h5 class="fw-bold mb-2 text-truncate textColorGreenVogue-title" [title]="slide?.title">
                      {{ slide?.title|slice:0:75}}...
                    </h5>
                    <div class="mt-2d-flex w-100 gap-3 justify-content-between mb-4">
                      <p class="mt-2 ellipsisText" [title]="slide?.description" *ngIf=" slide?.description">
                        {{ slide?.description}}
                      </p>
                    </div>
                    <div>
                      <button type="button" class="bg-orgclr submit-btn shadow-none" *ngIf="slide.ctaLabel"
                        (click)="goToLink(slide?.ctaTargetLink)"
                        style="position:absolute; max-width: 9rem; top: 156px; left: 6px;">
                        {{slide.ctaLabel?slide.ctaLabel : "DASHBOARD.BUYNOW" | translate }}
                      </button>
                    </div>
                  </div>
                  <div class="w-100" *ngIf=" slide?.templateType=='OFFER_NOTIFICATION'">
                    <div class=" mb-2 mt-1 ms-1 text-truncate textColorGreenVogue-title"
                      [title]="slide.offerHeadLine? slide.offerHeadLine:slide.title">
                      {{slide.offerHeadLine? slide.offerHeadLine:slide.title|slice:0:80}}
                    </div>
                    <div class=" ms-1 d-flex w-100 gap-3 justify-content-between"
                      *ngIf=" slide?.templateType=='OFFER_NOTIFICATION'">
                      <p class="textColorGreenVogue-description ellipsisText mb-0"
                        [title]="slide.offerDescription?slide.offerDescription:slide.description">
                        {{ slide?.offerDescription }}
                      </p>
                    </div>
                    <div>
                      <button type="button" class="bg-orgclr submit-btn shadow-none"
                        (click)="goToLink(slide?.ctaTargetLink)"
                        style="position:absolute; max-width: 9rem; top: 156px; left: 8px;">
                        {{slide.ctaLabel?slide.ctaLabel : "DASHBOARD.BUYNOW" | translate }}
                      </button>
                    </div>
                  </div>

                  <span *ngIf="slide?.templateType == 'OFFER_NOTIFICATION'" class="q-form-white-submits text-xs ms-5"
                    style="position:absolute;right: 15px;top: 10px;">
                    <img style="width: 32px;height: 32px;" alt=""
                      src="./assets/images/Rectangle 96offersnewcards.svg" />
                  </span>
                  <span *ngIf=" slide?.templateType=='ANNOUNCEMENT'" class=" q-form-white-submits text-xs ms-5"
                    style="position:absolute;right: 15px;top: 10px;">
                    <img style="width: 32px;height: 32px;" alt="" src="./assets/images/Blog (2).png" />
                  </span>
                  <span *ngIf=" slide?.templateType=='NEWS_INFO_BLOG'" class=" q-form-white-submits text-xs ms-5"
                    style="position:absolute;right: 15px;top: 10px;">
                    <img style="width: 32px;height: 32px;" alt="" src="./assets/images/Notenewblogs.png" />
                  </span>
                  <span *ngIf=" slide?.templateType=='SURVEY_FEEDBACK'" class=" q-form-white-submits text-xs ms-5"
                    style="position:absolute;right: 15px;top: 10px;">
                    <img style="width: 32px;height: 32px;" alt="" src="./assets/images/Component 7surveycard.svg" />
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="d-block d-md-none d-lg-none">
        <div *ngIf="(top3 )" [ngClass]=" getAllCampaignsData&&getAllCampaignsData.length <=3?'mt-3':'scroller mt-2'">
          <div class="p-3 ms-2 my-3 mt-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
            *ngFor="let slide of getAllCampaignsData;let i = index" [ngClass]="screenWidth<850?'':'heightFixed-alltab'"
            id="check">
            <ng-container class="w-100">
              <div class="relative ms-1">
                <div class="w-100 d-flex mt-2">
                  <div *ngIf=" slide?.templateType=='ANNOUNCEMENT'">
                    <span *ngIf="slide?.campaignType !='SYSTEM'">
                      <img *ngIf="slide.imagePromotional" [src]="slide.imagePromotional" alt=""
                        class="img-fluid  rounded-10 object-fit-contain" style="width: 97px;height: 52px;">
                    </span>
                    <img *ngIf="!slide?.imagePromotional" [src]="'IMAGES.ANNOUCEMENTEMPTY' | translate" alt=""
                      class="img-fluid rounded-10 object-fit-contain" style="width: 97px;height: 52px;" />
                    <span *ngIf=" (slide?.templateType=='ANNOUNCEMENT') &&(slide?.campaignType =='SYSTEM')">
                      <img *ngIf="slide.imagePromotional" [src]="slide.imagePromotional"
                        [ngClass]="(slide?.campaignType =='SYSTEM') && (!slide.ctaLabel)?'desktop-blog-img':'desktop-blog-img-small'"
                        alt="" class="img-fluid mt-1 rounded-10 object-fit-contain" />
                    </span>

                  </div>
                  <div *ngIf=" slide?.templateType=='OFFER_NOTIFICATION'">
                    <img *ngIf="slide.offerImage" [src]="slide.offerImage" alt=""
                      class="img-fluid  rounded-10 object-fit-contain  mt-1 ms-2" style="width: 100px;height: 58px;">
                    <img *ngIf="!slide.offerImage&&!slide.nooffer&&!slide.noSurvey&&!slide.title"
                      [src]="'IMAGES.OFFERPICNOTPRESENT' | translate" alt=""
                      class="img-fluid rounded-10 object-fit-contain  mt-1 ms-2" style="width: 100px;height: 58px;">
                    <img *ngIf="!slide.offerImage&&slide.noSurvey" [src]="'IMAGES.NOSURVEYEMPTYIMG' | translate" alt=""
                      class="img-fluid offerImageOffer  rounded-10 object-fit-contain  mt-1 ms-2">
                    <img *ngIf="!slide.offerImage&&slide.title&&!slide.noSurvey" [src]="'IMAGES.SURVEYIMG' | translate"
                      alt="" class="img-fluid offerImageOffer  rounded-10 object-fit-contain  mt-1 ms-2">
                  </div>
                  <div *ngIf=" (slide?.templateType=='NEWS_INFO_BLOG') &&(slide?.campaignType =='MOBILE')">
                    <img [src]="slide?.imagePromotional" alt="" class="img-fluid rounded-10 object-fit-contain"
                      style="width: 97px;height: 52px;" />
                  </div>
                  <span *ngIf=" (slide?.templateType=='NEWS_INFO_BLOG') &&(slide?.campaignType =='SYSTEM')">
                    <img *ngIf="slide.imagePromotional" [src]="slide.imagePromotional"
                      [ngClass]="(slide?.campaignType =='SYSTEM') && (!slide.ctaLabel)?'desktop-blog-img':'desktop-blog-img-small'"
                      alt="" class="img-fluid mt-1 rounded-10 object-fit-contain" />
                  </span>

                  <div *ngIf=" slide?.templateType=='SURVEY_FEEDBACK'">
                    <img src="./assets/images/Survery & Feedback (1) 1.svg" alt="" class="surveyimage" />
                  </div>
                  <div class=" mx-4 gap-2 mt-2">
                    <span class="gray-clr fw-bold-offers  textLineThrough">
                      {{(slide.productPrice&&slide.discount)?'Rs'+((slide.productPrice/(100-slide.discount))*100):''}}
                    </span>
                    <div class="org-clr fw-bold highlightedTextSize">{{slide.productPrice?('Rs'+slide.productPrice):''}}
                    </div>
                  </div>
                </div>
                <div class="w-100 d-flex mt-2 ms-1">
                  <div class="w-100" *ngIf=" slide?.templateType !='OFFER_NOTIFICATION'">
                    <h5 class="fw-bold mb-2 text-truncate textColorGreenVogue-title" [title]="slide?.title">
                      {{ slide?.title|slice:0:75}}...
                    </h5>
                    <div class="mt-2d-flex w-100 gap-3 justify-content-between mb-5">
                      <p class="mt-2 ellipsisText" [title]="slide?.description" *ngIf=" slide?.description">
                        {{ slide?.description}}
                      </p>
                    </div>
                    <div>
                      <button type="button" class="bg-orgclr submit-btn shadow-none" *ngIf="slide.ctaLabel"
                        (click)="goToLink(slide?.ctaTargetLink)"
                        style="position:absolute; max-width: 9rem; top: 136px; left: 6px;">
                        {{slide.ctaLabel?slide.ctaLabel : "DASHBOARD.BUYNOW" | translate }}
                      </button>
                    </div>
                  </div>



                  <div class="w-100" *ngIf=" slide?.templateType=='OFFER_NOTIFICATION'">
                    <div class=" mb-2 mt-1 ms-1 text-truncate textColorGreenVogue-title"
                      [title]="slide.offerHeadLine? slide.offerHeadLine:slide.title">
                      {{slide.offerHeadLine? slide.offerHeadLine:slide.title|slice:0:80}}
                    </div>
                    <div class=" ms-1 d-flex w-100 gap-3 justify-content-between"
                      *ngIf=" slide?.templateType=='OFFER_NOTIFICATION'">
                      <p class="textColorGreenVogue-description ellipsisText mb-5"
                        [title]="slide.offerDescription?slide.offerDescription:slide.description">
                        {{ slide?.offerDescription }}
                      </p>
                    </div>
                    <div>
                      <button type="button" class="bg-orgclr submit-btn shadow-none"
                        (click)="goToLink(slide?.ctaTargetLink)"
                        style="position:absolute; max-width: 9rem; top: 136px; left: 8px;">
                        {{slide.ctaLabel?slide.ctaLabel : "DASHBOARD.BUYNOW" | translate }}
                      </button>
                    </div>
                  </div>

                  <span *ngIf="slide?.templateType == 'OFFER_NOTIFICATION'" class="q-form-white-submits text-xs ms-5"
                    style="position:absolute;right: 15px;top: 10px;">
                    <img style="width: 32px;height: 32px;" alt=""
                      src="./assets/images/Rectangle 96offersnewcards.svg" />
                  </span>
                  <span *ngIf=" slide?.templateType=='ANNOUNCEMENT'" class=" q-form-white-submits text-xs ms-5"
                    style="position:absolute;right: 15px;top: 10px;">
                    <img style="width: 32px;height: 32px;" alt="" src="./assets/images/Blog (2).png" />
                  </span>
                  <span *ngIf=" slide?.templateType=='NEWS_INFO_BLOG'" class=" q-form-white-submits text-xs ms-5"
                    style="position:absolute;right: 15px;top: 10px;">
                    <img style="width: 32px;height: 32px;" alt="" src="./assets/images/Notenewblogs.png" />
                  </span>
                  <span *ngIf=" slide?.templateType=='SURVEY_FEEDBACK'" class=" q-form-white-submits text-xs ms-5"
                    style="position:absolute;right: 15px;top: 10px;">
                    <img style="width: 32px;height: 32px;" alt="" src="./assets/images/Component 7surveycard.svg" />
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div *ngIf="(isblog) &&(getMyBlog?.length === 1)"
        class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
        [ngClass]="screenWidth<850?'':'offerImageBlog-emptycard-all '">
        <div class="col-sm-12 text-center">
          <div class="two-empty-container mt-5 ms-0">
            <div class="center">
              <span class=" ms-3">
                <img class="empty-image" alt="" src="./assets/images/Group 1000007422EmptyCampaign.svg" />
              </span>
              <div class="mt-3 mb-5 ms-3">
                <span class="empty-report-text">{{ "DASHBOARD.NOARTICLESORBLOGS" | translate }}</span>
                <div class="mt-2 d-flex align-items-center wrapperBlog-twoempty-card">
                  <h6 class="two-empty-campgincard mb-1 ms-1">
                    {{ "DASHBOARD.EMPTYCARDBLOG" | translate }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="(issurvey) &&(getMySurvey?.length === 1)"
        class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
        [ngClass]="screenWidth<850?'':'offerImageBlog-emptycard-all '">
        <div class="col-sm-12 text-center">
          <div class="two-empty-container mt-5 ms-0">
            <div class="center">
              <span class=" ms-3">
                <img class="empty-image" alt="" src="./assets/images/Group 1000007422EmptyCampaign.svg" />
              </span>
              <div class="mt-3 mb-5 ms-3">
                <span class="empty-report-text">{{ "DASHBOARD.NOARTICLESORBLOGS" | translate }}</span>
                <div class="mt-2 d-flex align-items-center wrapperBlog-twoempty-card">
                  <h6 class="two-empty-campgincard mb-1 ms-1">
                    {{ "DASHBOARD.EMPTYCARDSURVEY" | translate }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="(isAnnouncemnt) &&(getMyAnnounce?.length === 1)"
        class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
        [ngClass]="screenWidth<850?'':'offerImageBlog-emptycard-all '">
        <div class="col-sm-12 text-center">
          <div class="two-empty-container mt-5 ms-0">
            <div class="center">
              <span class=" ms-3">
                <img style="width: 160px;height: 105px;" alt=""
                  src="./assets/images/Group 1000007422EmptyCampaign.svg" />
              </span>
              <div class="mt-3 mb-5 ms-3">
                <span class="empty-report-text">{{ "DASHBOARD.NOARTICLESORBLOGS" | translate }}</span>
                <div class="mt-2 d-flex align-items-center wrapperBlog-twoempty-card">
                  <h6 class="two-empty-campgincard mb-1 ms-1">
                    {{ "DASHBOARD.EMPTYCARDANNOUNCEMENT" | translate }}
                  </h6>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="(isOffer) &&(getMyOffer?.length === 1)"
        class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
        [ngClass]="screenWidth<850?'':'offerImageBlog-emptycard-all '">
        <div class="col-sm-12 text-center">
          <div class="two-empty-container mt-5 ms-0">
            <div class="center">
              <span class=" ms-3">
                <img class="empty-image" alt="" src="./assets/images/Group 1000007422EmptyCampaign.svg" />
              </span>
              <div class="mt-3 mb-5 ms-3">
                <span class="empty-report-text">{{ "DASHBOARD.NOARTICLESORBLOGS" | translate }}</span>
                <div class="mt-2 d-flex align-items-center wrapperBlog-twoempty-card">
                  <h6 class="two-empty-campgincard  mb-1 ms-1">
                    {{ "DASHBOARD.EMPTYCARDOFFER" | translate }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="(isblog ) && (!getMyBlog ||getMyBlog?.length === 0)"
        class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
        [ngClass]="screenWidth<850?'':'offerImageBlog-emptycard '">
        <div class="col-sm-12 text-center">
          <div class="container mt-5 ms-0">
            <div class="center">
              <span class=" ms-3">
                <img class="empty-image" alt="" src="./assets/images/Group 1000007422EmptyCampaign.svg" />
              </span>
              <div class="mt-3 mb-5 ms-3">
                <span class="empty-report-text">{{ "DASHBOARD.NOARTICLESORBLOGS" | translate }}</span>
                <div class="mt-2 d-flex align-items-center wrapperBlog">
                  <h6 class="all-empty-campgincard mb-1 ms-3">
                    {{ "DASHBOARD.EMPTYCARDBLOG" | translate }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="(isOffer ) && (!getMyOffer ||getMyOffer?.length === 0)"
        class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
        [ngClass]="screenWidth<850?'':'offerImageBlog-emptycard '">
        <div class="col-sm-12 text-center">
          <div class="container mt-5 ms-0">
            <div class="center">
              <span class=" ms-3">
                <img class="empty-image" alt="" src="./assets/images/Group 1000007422EmptyCampaign.svg" />
              </span>
              <div class="mt-3 mb-5 ms-3">
                <span class="empty-report-text">{{ "DASHBOARD.NOARTICLESORBLOGS" | translate }}</span>
                <div class="mt-2 d-flex align-items-center wrapperBlog">
                  <h6 class="all-empty-campgincard mb-1 ms-3">
                    {{ "DASHBOARD.EMPTYCARDOFFER" | translate }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="(issurvey ) && (!getMySurvey ||getMySurvey?.length === 0)"
        class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
        [ngClass]="screenWidth<850?'':'offerImageBlog-emptycard '">
        <div class="col-sm-12 text-center">
          <div class="container mt-5 ms-0">
            <div class="center">
              <span class=" ms-3">
                <img class="empty-image" alt="" src="./assets/images/Group 1000007422EmptyCampaign.svg" />
              </span>
              <div class="mt-3 mb-5 ms-3">
                <span class="empty-report-text">{{ "DASHBOARD.NOARTICLESORBLOGS" | translate }}</span>
                <div class="mt-2 d-flex align-items-center wrapperBlog">
                  <h6 class="all-empty-campgincard mb-1 ms-3">
                    {{ "DASHBOARD.EMPTYCARDSURVEY" | translate }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="(isAnnouncemnt ) && (!getMyAnnounce ||getMyAnnounce?.length === 0)"
        class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
        [ngClass]="screenWidth<850?'':'offerImageBlog-emptycard '">
        <div class="col-sm-12 text-center">
          <div class="container mt-5 ms-0">
            <div class="center">
              <span class=" ms-3">
                <img class="empty-image" alt="" src="./assets/images/Group 1000007422EmptyCampaign.svg" />
              </span>
              <div class="mt-3 mb-5 ms-3">
                <span class="empty-report-text">{{ "DASHBOARD.NOARTICLESORBLOGS" | translate }}</span>
                <div class="mt-2 d-flex align-items-center wrapperBlog">
                  <h6 class="all-empty-campgincard mb-1 ms-3">
                    {{ "DASHBOARD.EMPTYCARDANNOUNCEMENT" | translate }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isAnnouncemnt && getMyAnnounce?.length === 2"
        class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
        [ngClass]="screenWidth<850?'':'offerImageBlog-emptycard-single '">
        <div class="col-sm-12 text-center">
          <div class="single-empty-card-container mt-5 ms-0">
            <div class="center">
              <span class=" ms-3">
                <img class="empty-twocard-image" alt="" src="./assets/images/Group 1000007422EmptyCampaign.svg" />
              </span>
              <div class="mt-3 mb-5 ms-3">
                <span class="empty-report-text">{{ "DASHBOARD.NOARTICLESORBLOGS" | translate }}</span>
                <div class="mt-2 d-flex align-items-center wrapperBlog">
                  <h6 class="textColorGreenVogue-single-campgincard mb-1 ms-3">
                    {{ "DASHBOARD.EMPTYCARDANNOUNCEMENT" | translate }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="issurvey && getMySurvey?.length === 2"
        class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
        [ngClass]="screenWidth<850?'':'offerImageBlog-emptycard-single '">
        <div class="col-sm-12 text-center">
          <div class="single-empty-card-container mt-5 ms-0">
            <div class="center">
              <span class=" ms-3">
                <img class="empty-twocard-image" alt="" src="./assets/images/Group 1000007422EmptyCampaign.svg" />
              </span>
              <div class="mt-3 mb-5 ms-3">
                <span class="empty-report-text">{{ "DASHBOARD.NOARTICLESORBLOGS" | translate }}</span>
                <div class="mt-2 d-flex align-items-center wrapperBlog">
                  <h6 class="textColorGreenVogue-single-campgincard mb-1 ms-3">
                    {{ "DASHBOARD.EMPTYCARDSURVEY" | translate }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isblog && getMyBlog?.length === 2"
        class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
        [ngClass]="screenWidth<850?'':'offerImageBlog-emptycard-single'">
        <div class="col-sm-12 text-center">
          <div class="single-empty-card-container mt-5 ms-0">
            <div class="center">
              <span class=" ms-3">
                <img class="empty-twocard-image" alt="" src="./assets/images/Group 1000007422EmptyCampaign.svg" />
              </span>
              <div class="mt-3 mb-5 ms-3">
                <span class="empty-report-text">{{ "DASHBOARD.NOARTICLESORBLOGS" | translate }}</span>
                <div class="mt-2 d-flex align-items-center wrapperBlog">
                  <h6 class="textColorGreenVogue-single-campgincard mb-1 ms-3">
                    {{ "DASHBOARD.EMPTYCARDBLOG" | translate }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isOffer && getMyOffer?.length === 2"
        class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
        [ngClass]="screenWidth<850?'':'offerImageBlog-emptycard-single'">
        <div class="col-sm-12 text-center">
          <div class="single-empty-card-container mt-5 ms-0">
            <div class="center">
              <span class=" ms-3">
                <img class="empty-twocard-image" alt="" src="./assets/images/Group 1000007422EmptyCampaign.svg" />
              </span>
              <div class="mt-3 mb-5 ms-3">
                <span class="empty-report-text">{{ "DASHBOARD.NOARTICLESORBLOGS" | translate }}</span>
                <div class="mt-2 d-flex align-items-center wrapperBlog">
                  <h6 class="textColorGreenVogue-single-campgincard mb-1 ms-3">
                    {{ "DASHBOARD.EMPTYCARDOFFER" | translate }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="top3 && getAllCampaignsData?.length === 2"
        class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
        [ngClass]="screenWidth<850?'':'offerImageBlog-emptycard-single '">
        <div class="col-sm-12 text-center">
          <div class="single-empty-card-container mt-5 ms-0">
            <div class="center">
              <span class=" ms-3">
                <img class="empty-twocard-image" alt="" src="./assets/images/Group 1000007422EmptyCampaign.svg" />
              </span>
              <div class="mt-3 mb-5 ms-3">
                <span class="empty-report-text">{{ "DASHBOARD.NOARTICLESORBLOGS" | translate }}</span>
                <div class="mt-2 d-flex align-items-center wrapperBlog">
                  <h6 class="textColorGreenVogue-single-campgincard mb-1 ms-3">
                    {{ "DASHBOARD.EMPTYCARDCAMPAIGN" | translate }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="(top3) &&(getAllCampaignsData?.length === 1)"
        class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
        [ngClass]="screenWidth<850?'':'offerImageBlog-emptycard-all '">
        <div class="col-sm-12 text-center">
          <div class="two-empty-container mt-5 ms-0">
            <div class="center">
              <span class=" ms-3">
                <img class="empty-image" alt="" src="./assets/images/Group 1000007422EmptyCampaign.svg" />
              </span>
              <div class="mt-3 mb-5 ms-3">
                <span class="empty-report-text">{{ "DASHBOARD.NOARTICLESORBLOGS" | translate }}</span>
                <div class="mt-2 d-flex align-items-center wrapperBlog-twoempty-card">
                  <h6 class="two-empty-campgincard mb-1 ms-1">
                    {{ "DASHBOARD.EMPTYCARDCAMPAIGN" | translate }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="(top3 ) && (!getAllCampaignsData ||getAllCampaignsData?.length === 0)"
        class="p-3 ms-2 my-3 mb-xl-2 rounded-15 textColorGreenVogue bg-white me-4"
        [ngClass]="screenWidth<850?'':'offerImageBlog-emptycard '">
        <div class="col-sm-12 text-center">
          <div class="container mt-5 ms-0">
            <div class="center">
              <span class=" ms-3">
                <img class="empty-image" alt="" src="./assets/images/Group 1000007422EmptyCampaign.svg" />
              </span>
              <div class="mt-3 mb-5 ms-3">
                <span class="empty-report-text">{{ "DASHBOARD.NOARTICLESORBLOGS" | translate }}</span>
                <div class="mt-2 d-flex align-items-center wrapperBlog">
                  <h6 class="all-empty-campgincard mb-1 ms-3">
                    {{ "DASHBOARD.EMPTYCARDCAMPAIGN" | translate }}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div *ngIf="isCarouselVisible" class="notification-panel mt-4-1 " [class.hidden]="!notification"
      [ngClass]="{ 'right-align': isShortMessagePanel() }" [ngClass]="{'right-align': isPanelOpen}">
      <ng-container *ngIf="notification">
        <ng-container>
          <div class="rounded-20 mt-4 ms-2 pb-3">
            <div class="notifyb-bar">
              <div class="notification-text px-4">
                <h5 class="notification-text fw-bold mb-3 mt-3">
                  {{ "DASHBOARD.NOTIFICATION" | translate }}
                </h5>
                <span (click)="closeModal4()" class="closeModal">
                  <img src="./assets/images/otpCancel.svg" alt="" class="ms-xl-4" />
                </span>
              </div>

              <!-- <div [ngClass]="{ 'notifyb-bar custom-width': totallicenseFreeCount > 0 && groupedNotifications.length === 0 }" class="empty-notification-div text-center text-muted my-5">
                <div >
                  <img class="mx-auto d-block" src="./assets/images/Group 1000008910.svg" />
                </div>
              </div> -->
              <div *ngIf="groupedNotifications.length === 0">
                <div
                  [ngClass]="{ 'notifyb-bar custom-width': totallicenseFreeCount > 0 && groupedNotifications.length === 0 }"
                  class="empty-notification-div text-muted my-5 center-wrap">
                  <div class="">
                    <img src="./assets/images/Group 1000008910.svg" alt="Notification" />
                  </div>
                </div>
              </div>


              <div class="ms-0 mt-4 all-button">
                <button
                  [ngClass]=" AllNotCount === 0 ? 'buttonsClickfocus opacity-50' : (selectedNotType != 'All') ? 'buttonsClick' : 'buttonsClickfocus'"
                  [disabled]="AllNotCount === 0" (click)="selectNotificationType('All');filterNotification('ALL')">{{
                  "MANAGEDEVICE.ALL" |
                  translate }} {{ " ("+ viewAllNotCount +")" }}
                </button>
                <button class="ms-2"
                  [ngClass]="alertNotCount === 0 ? 'buttonsClick opacity-50' : selectedNotType != 'Alerts'?'buttonsClick' : 'buttonsClickfocus'"
                  [disabled]="alertNotCount === 0"
                  (click)="selectNotificationType('Alerts');filterNotification('ALERT')">{{
                  "DASHBOARD.ALERTS" |
                  translate }} {{ " ("+ viewAlertNotCount +")" }}
                </button>
                <button class="ms-2"
                  [ngClass]="infoNotCount === 0 ? 'buttonsClick opacity-50' : selectedNotType != 'Information'?'buttonsClick' : 'buttonsClickfocus'"
                  [disabled]="infoNotCount === 0"
                  (click)="selectNotificationType('Information');filterNotification('INFO')">{{
                  "DASHBOARD.INFORMATIONNOT"
                  |
                  translate }} {{ " ("+ viewInfoNotCount +")" }}
                </button>
              </div>

              <!-- Loop through each device -->
              <div class="mt-5 notification-list" *ngIf="groupedNotifications.length > 0">
                <div *ngFor="let device of groupedNotifications let i = index">
                  <div class="align-items-start mb-1 mt-2">
                    <div class="ms-1 text-start mt-2">
                      <!-- Device Name -->
                      <div class="justify-content-between align-items-center ">
                        <div class="fw-bold ms-4 mt-4">{{ device.date }} {{'('+ device.notifications.length +')'}}</div>
                      </div>

                      <!-- Loop through each notification of this device -->
                      <div *ngFor="let notify of device.notifications"
                        class="ms-xl-3 ps-1 mt-1 notification-item border-bottom mb-2"
                        (click)="!notify.viewTime && markAsRead(notify)"
                        [ngClass]="{'border-bottom': i !== groupedNotifications.length-1}">
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="fw-bold notification-device-name-text">

                            <span *ngIf="notify?.deviceType === 'SYSTEM' && notify?.notificationCat==='ALERT'">
                              <img src="../../../assets/images/Desktop_alert.png" alt="Laptop with alert"
                                class="ms-0 me-0 mt-0 pt-0 pb-1" />
                            </span>

                            <!-- When SYSTEM and alerts is false -->
                            <span *ngIf="notify?.deviceType === 'SYSTEM' && notify?.notificationCat==='INFO'">
                              <img src="../../../assets/images/Laptop.png" alt="Laptop"
                                class="ms-0 me-0 mt-0 pt-0 pb-1" />
                            </span>

                            <span *ngIf="notify?.deviceType === 'MOBILE' && notify?.notificationCat==='ALERT'">
                              <img src="../../../assets/images/mobile_alert.png" alt="Mobile with alert"
                                class="ms-1 me-1 mt-0 pt-0 pb-1" />
                            </span>
                            <span *ngIf="notify?.deviceType === 'MOBILE' && notify?.notificationCat==='INFO'">
                              <img src="../../../assets/images/Rectangle 83.png" alt="Mobile"
                                class="ms-1 me-1 mt-0 pt-0 pb-1" />
                            </span>
                            {{ notify.deviceName }}
                            <span
                              *ngIf="notify.notificationType === 'EXPIRY' || notify.systemNotificationType === 'EXPIRY_NOTIFICATION'">
                              <span *ngIf="notify.expiryStatus === 'LICENSE_EXPIRING_SOON'">
                                - {{ 'NOTIFICATION.RENEW_LICENSE' | translate }}
                              </span>
                              <span *ngIf="notify.expiryStatus === 'LICENSE_EXPIRED'">
                                - {{ 'NOTIFICATION.LICENSE_EXPIRED' | translate }}
                              </span>
                            </span>
                          </div>
                          <div class="d-flex notification-message-text">
                            <div>
                              {{ notify.notTime }}
                            </div>

                            <div>
                              <span
                                *ngIf="!notify.viewTime && notify.notificationType != 'EXPIRY' && notify.systemNotificationType != 'EXPIRY_NOTIFICATION'"
                                (click)="markAsRead(notify)" title="Mark as read" class="ms-2 cursor-pointer">
                                <img src="../../../assets/images/markAsReadDot.svg" alt=""
                                  class="ms-1 mt-0 pt-0 pb-1" />
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class=" mt-2 d-flex align-items-center justify-content-between">
                          <div class="me-2 ms-xl-4 notification-message-text">
                            {{ getNotificationMessage(notify) }}
                          </div>
                        </div>
                        <div *ngIf="notify.actionablePrompt === true" class="mt-2">
                          <div *ngIf="notify.notificationType === 'EXPIRY'">
                            <button
                              class="bg-orgclr ms-4 submit-btn-renew  renew-btn  right-end mb-2 renew-notification-btn"
                              (click)="checkBeforeRenew(notify.purchaseLink,notify.productType, notify.crwDomainUrl)">{{
                              "LICENSESUMMARY.RENEW" |
                              translate }}</button>
                          </div>
                          <div *ngIf="notify.systemNotificationType === 'EXPIRY_NOTIFICATION'">
                            <button
                              class="bg-orgclr ms-4 submit-btn-renew  renew-btn  right-end mb-2 renew-notification-btn"
                              (click)="checkBeforeRenew(notify.purchaseLink,notify.productType, notify.crwDomainUrl)">{{
                              "LICENSESUMMARY.RENEW" |
                              translate }}</button>
                          </div>
                        </div>
                        <!-- Setiing Failure Case : Send a Request Button -->
                        <div class="mt-2"
                          *ngIf="notify.systemNotificationType === 'SETTING_FAILURE' || notify.notificationType == 'SETTING_FAILURE'">
                          <button class="ms-4 bg-orgclr submit-btn-renew  renew-btn  right-end mb-0 font-700-12"
                            (click)="openSendControlPopup(notify.deviceId,notify.settingType,notify.deviceType,notify.deviceName)">{{
                            "MANAGEDEVICE.ACTNOW" |
                            translate }}</button>
                        </div>
                        <!-- <div class="text-muted small">
                    {{ notify.time ? (notify.time | date: 'medium') : '' }}
                  </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bg-white mb-3 not-me-end"
                *ngIf="((selectedNotType === 'All' || selectedNotType === 'ALL') && viewAllNotCount >= 5) || (selectedNotType === 'Alerts' && viewAlertNotCount >= 5) || (selectedNotType === 'Information' && viewInfoNotCount >= 5)">
                <div class="mx-3 me-1 bg-white">
                  <button class="py-2 px-4  w-100 view-notification-more-link justify-content-center"
                    (click)=viewMore()>
                    {{"MANAGEDEVICE.VIEWMORE" |translate }}
                  </button>
                  <span class="pe-1"></span>
                </div>
              </div>
            </div>





          </div>
        </ng-container>
      </ng-container>
    </div>

    <ng-container *ngIf="notification && !isCarouselVisible">
      <ng-container>
        <div class="rounded-20 ms-2 pb-3">
          <div class="notifyb-bar">
            <div class="notification-text px-4">
              <h5 class="notification-text fw-bold mb-3 mt-3">
                {{ "DASHBOARD.NOTIFICATION" | translate }}
              </h5>
              <span (click)="closeModal4()" class="closeModal">
                <img src="./assets/images/otpCancel.svg" alt="" class="ms-xl-4" />
              </span>
            </div>

            <div *ngIf="groupedNotifications.length === 0" class="empty-notification-div text-center text-muted my-5">
              <div class="">
                <img class="" src="./assets/images/Group 1000008910.svg" />
              </div>
            </div>

            <div class="ms-0 mt-4 all-button">
              <button
                [ngClass]=" AllNotCount === 0 ? 'buttonsClickfocus opacity-50' : (selectedNotType != 'All') ? 'buttonsClick' : 'buttonsClickfocus'"
                [disabled]="AllNotCount === 0" (click)="selectNotificationType('All');filterNotification('ALL')">{{
                "MANAGEDEVICE.ALL" |
                translate }} {{ " ("+ viewAllNotCount +")" }}
              </button>
              <button class="ms-2"
                [ngClass]="alertNotCount === 0 ? 'buttonsClick opacity-50' : selectedNotType != 'Alerts'?'buttonsClick' : 'buttonsClickfocus'"
                [disabled]="alertNotCount === 0"
                (click)="selectNotificationType('Alerts');filterNotification('ALERT')">{{
                "DASHBOARD.ALERTS" |
                translate }} {{ " ("+ viewAlertNotCount +")" }}
              </button>
              <button class="ms-2"
                [ngClass]="infoNotCount === 0 ? 'buttonsClick opacity-50' : selectedNotType != 'Information'?'buttonsClick' : 'buttonsClickfocus'"
                [disabled]="infoNotCount === 0"
                (click)="selectNotificationType('Information');filterNotification('INFO')">{{ "DASHBOARD.INFORMATIONNOT"
                |
                translate }} {{ " ("+ viewInfoNotCount +")" }}
              </button>
            </div>

            <!-- Loop through each device -->
            <div class="mt-5 notification-list" *ngIf="groupedNotifications.length > 0">
              <div *ngFor="let device of groupedNotifications; let i = index">
                <div class="align-items-start mb-1 mt-2">
                  <div class="ms-1 text-start mt-2">
                    <!-- Device Name -->
                    <div class="justify-content-between align-items-center ">
                      <div class="fw-bold ms-4 mt-4">{{ device.date }} {{'('+ device.notifications.length +')'}}</div>
                    </div>

                    <!-- Loop through each notification of this device -->
                    <div *ngFor="let notify of device.notifications"
                      class="ms-xl-3 ps-1 mt-1 notification-item border-bottom mb-2"
                      (click)="!notify.viewTime && markAsRead(notify)"
                      [ngClass]="{'border-bottom': i !== groupedNotifications.length-1}">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="fw-bold notification-device-name-text">
                          <span *ngIf="notify?.deviceType === 'SYSTEM' && notify?.notificationCat==='ALERT'">
                            <img src="../../../assets/images/Desktop_alert.png" alt="Laptop with alert"
                              class="ms-0 me-0 mt-0 pt-0 pb-1" />
                          </span>

                          <!-- When SYSTEM and alerts is false -->
                          <span *ngIf="notify?.deviceType === 'SYSTEM' && notify?.notificationCat==='INFO'">
                            <img src="../../../assets/images/Laptop.png" alt="Laptop"
                              class="ms-0 me-0 mt-0 pt-0 pb-1" />
                          </span>
                          <span *ngIf="notify?.deviceType === 'MOBILE' && notify?.notificationCat==='ALERT'">
                            <img src="../../../assets/images/mobile_alert.png" alt=""
                              class="ms-1 me-1 mt-0 pt-0 pb-1" />
                          </span>
                          <span *ngIf="notify?.deviceType === 'MOBILE' && notify?.notificationCat==='INFO'">
                            <img src="../../../assets/images/Rectangle 83.png" alt=""
                              class="ms-1 me-1 mt-0 pt-0 pb-1" />
                          </span>
                          {{ notify.deviceName }}
                          <span
                            *ngIf="notify.notificationType === 'EXPIRY' || notify.systemNotificationType === 'EXPIRY_NOTIFICATION'">
                            <span *ngIf="notify.expiryStatus === 'LICENSE_EXPIRING_SOON'">
                              - {{ 'NOTIFICATION.RENEW_LICENSE' | translate }}
                            </span>
                            <span *ngIf="notify.expiryStatus === 'LICENSE_EXPIRED'">
                              - {{ 'NOTIFICATION.LICENSE_EXPIRED' | translate }}
                            </span>
                          </span>
                        </div>
                        <div class="d-flex notification-message-text">
                          <div>
                            {{ notify.notTime }}
                          </div>

                          <div>
                            <span
                              *ngIf="!notify.viewTime && notify.notificationType != 'EXPIRY' && notify.systemNotificationType != 'EXPIRY_NOTIFICATION'"
                              (click)="markAsRead(notify)" title="Mark as read" class="ms-2 cursor-pointer">
                              <img src="../../../assets/images/markAsReadDot.svg" alt="" class="ms-1 mt-0 pt-0 pb-1" />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class=" mt-2 d-flex align-items-center justify-content-between">
                        <div class="me-2 ms-xl-4 notification-message-text">
                          {{ getNotificationMessage(notify) }}
                        </div>
                      </div>
                      <div *ngIf="notify.actionablePrompt === true" class="mt-2">
                        <div *ngIf="notify.notificationType === 'EXPIRY'">
                          <button class="bg-orgclr ms-4 submit-btn-renew  renew-btn  right-end mb-2" style="width:92px;"
                            (click)="checkBeforeRenew(notify.purchaseLink,notify.productType, notify.crwDomainUrl)">{{
                            "LICENSESUMMARY.RENEW" |
                            translate }}</button>
                        </div>
                        <div *ngIf="notify.systemNotificationType === 'EXPIRY_NOTIFICATION'">
                          <button class="bg-orgclr ms-4 submit-btn-renew  renew-btn  right-end mb-2" style="width:92px;"
                            (click)="checkBeforeRenew(notify.purchaseLink,notify.productType, notify.crwDomainUrl)">{{
                            "LICENSESUMMARY.RENEW" |
                            translate }}</button>
                        </div>
                      </div>
                      <!-- Setiing Failure Case : Send a Request Button -->
                      <div class="mt-2"
                        *ngIf="notify.systemNotificationType === 'SETTING_FAILURE' || notify.notificationType == 'SETTING_FAILURE'">
                        <button class="ms-4 bg-orgclr submit-btn-renew  renew-btn  right-end mb-0 font-700-12"
                          (click)="openSendControlPopup(notify.deviceId,notify.settingType,notify.deviceType,notify.deviceName)">{{
                          "MANAGEDEVICE.ACTNOW" |
                          translate }}</button>
                      </div>
                      <!-- <div class="text-muted small">
                    {{ notify.time ? (notify.time | date: 'medium') : '' }}
                  </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bg-white mb-3 not-me-end"
              *ngIf="((selectedNotType === 'All' || selectedNotType === 'ALL') && viewAllNotCount >= 5) || (selectedNotType === 'Alerts' && viewAlertNotCount >= 5) || (selectedNotType === 'Information' && viewInfoNotCount >= 5)">
              <div class="mx-3 me-1 bg-white">
                <button class="py-2 px-4  w-100 view-notification-more-link justify-content-center" (click)=viewMore()>
                  {{"MANAGEDEVICE.VIEWMORE" |translate }}
                </button>
                <span class="pe-1"></span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <!-- new security place -->
  </div>

</div>

<!-- blog and security -->

<div class="row mb-5">
</div>

<div class="modal" id="verifyDetailsPopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered" id="forgotpwd">
    <ng-container *ngIf="isMobile">
      <div class="modal-content p-3 forgotpwd rounded-25">
        <!-- Modal Header -->
        <div class="text-center mx-4">
          <h5 class="my-2">
            <app-main-heading>
              <span title> {{ "MANAGEDEVICE.VERIFYDETAILS" | translate }}</span>
            </app-main-heading>
          </h5>
          <p class="text-xs">
            {{ "MANAGEDEVICE.PLEASEADDMOBILE" | translate }}
          </p>
        </div>
        <!-- Modal body -->
        <form [formGroup]="deviceDetailForm" (ngSubmit)="verifyDeviceDetail()">
          <div class="form-div">
            <div class="form-group mb-3">
              <label for="mblNumoremail" class="mb-1 q-form-label">{{ "MANAGEDEVICE.MOBILENO" | translate }}
                <span class="text-danger">*</span></label>
              <ngx-intl-tel-input [cssClass]="'form-control q-form-control'" [preferredCountries]="[
                  CountryISO.India,
                  CountryISO.UnitedKingdom
                ]" [enableAutoCountrySelect]="false" [enablePlaceholder]="true"
                customPlaceholder="{{ 'SIGNUP.ENTERYOURMBLNO' | translate }}" [searchCountryFlag]="true"
                [searchCountryField]="[
                  SearchCountryField.Iso2,
                  SearchCountryField.Name
                ]" [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India" [maxLength]="15"
                [phoneValidation]="true" name="phone" formControlName="userName" (keydown)="removeSpace($event)"
                (keypress)="keyPressAlphaNumericWithCharacters($event)" (ngModelChange)="onFocusOutMobile($event)">
              </ngx-intl-tel-input>
              <ng-container *ngIf="mobileNoWrong">
                <p class="errMessage">
                  {{ "MANAGEDEVICE.MINANDMAX8" | translate }}
                </p>
              </ng-container>
            </div>

            <div class="mt-3 mb-4">
              <button type="submit" [disabled]="deviceDetailForm.controls['userName'].value?.number?.length<8"
                [ngClass]="
                  deviceDetailForm.controls['userName'].value?.number?.length<8
                    ? 'q-invalid-button mb-3 w-100'
                    : 'submit-btn bg-orgclr mb-3 w-100'
                ">
                {{ "LOGIN.SUBMIT" | translate }}
              </button>
              <button type="button" class="cancel-btn bg-cancelbtn w-100" (click)="closeModalForMobileNumber()">
                {{ "LOGIN.CANCEL" | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </ng-container>
    <ng-container *ngIf="isOTP">
      <div class="modal-content p-3 enterotp">
        <div class="text-center mt-3">
          <h5 class="mb-0">
            <app-main-heading>
              <span title> {{ "LOGIN.ENTEROTP" | translate }}</span>
            </app-main-heading>
          </h5>
          <small>{{ "LOGIN.SENTON" | translate }} {{ mobileNumber }}</small>
        </div>
        <!-- Modal body -->
        <div class="">
          <div class="mt-4 form-group">
            <div class="d-flex justify-content-center align-items-center mt-1 mb-2">
              <span>
                <div class="charClass me-2 me-md-3">
                  {{ emailResponse }}
                </div>
              </span>
              <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{ length: 4, allowNumbersOnly: true }"
                #ngOtpInput>
              </ng-otp-input>
            </div>
          </div>
          <ng-container *ngIf="otpError">
            <p class="errMessage" style="margin: 10px 90px">{{ otpError }}</p>
          </ng-container>
          <div class="mt-4 mb-3 form-div">
            <button type="button" class="submit-btn bg-orgclr w-100 mb-3" (click)="submitOTP()">
              {{ "LOGIN.SUBMIT" | translate }}
            </button>
            <button type="button" class="cancel-btn bg-cancelbtn w-100" (click)="closeModalForMobileNumber()">
              {{ "LOGIN.CANCEL" | translate }}
            </button>
          </div>

          <ng-container *ngIf="isOTP && timeOver">
            <div class="d-flex align-items-center justify-content-center mb-3">
              <small>
                {{ "RESENDOT.RESENDOTPIN" | translate }}
                {{ durationMinutes }}</small>
            </div>
          </ng-container>
          <div class="d-flex mt-2 align-items-center justify-content-center notOtpDiv mb-3" *ngIf="!timeOver && isOTP">
            <span>{{ "LOGIN.DIDNTRECEIVEOTP" | translate }}</span>
            <button type="button" class="border-0 bg-white cursor-pointer resend-Otp shadow-none outline-none p-0 ms-2"
              (click)="resendOtp()">
              {{ "LOGIN.RESEND" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isDone">
      <div
        class="modal-content rounded-25 border-none shadow-lg relative d-flex flex-column w-100 pointer-events-auto bg-white outline-none">
        <div class="modal-body relative pt-3">
          <div class="text-center mt-3">
            <div>
              <img [src]="'SIGNUP.SUCCESSIMG' | translate" alt="" class="mx-auto" />
            </div>
            <h5 class="fw-bold mt-3 mb-3">
              {{ "SUCESSMESSAGE.PHONEVERIFIED" | translate }}
            </h5>
            <button class="submit-btn bg-orgclr w-auto" (click)="closeVerifyDetails()">
              {{ "SIGNUP.DONE" | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>


<!-- Multiple controls stopped working! Popup -->

<div class="modal" id="controlRequestPopup" data-bs-backdrop="static">
  <div class="modal-dialog opt-popup relative w-auto pointer-events-none actOncontrolPopupWidth modal-dialog-centered">
    <div
      class="modal-content border-none rounded-25 shadow-lg actOncontrolPopupWidth relative d-flex p-3 p-md-4 flex-column w-100 pointer-events-auto outline-none modal-dialog-centered">
      <!-- Modal Header -->
      <div class="mt-0 actOncontrolPopupWidth" *ngIf="requestTypes.split(',').length > 1">
        <h4>
          <app-main-heading>
            <span class="text-transform-none" title>{{ "DASHBOARD.MULTIPLECONTROLSTOPPEDWORK" | translate }}</span>
          </app-main-heading>
        </h4>
      </div>

      <div class="mt-0 actOncontrolPopupWidth" *ngIf="!(requestTypes.split(',').length > 1)">
        <h4 class="popup-heading-wrapper">
          <app-main-heading>
            <span class="popup-heading" title> {{ "DASHBOARD."+requestTypes.trim() | translate }} {{
              "DASHBOARD.HASSTOPPEDWORKING" |
              translate }}</span>
          </app-main-heading>
        </h4>
      </div>

      <!-- Modal body -->
      <div class="mt-3 device-control-popup">
        <div class="Username">
          <span><img src="./assets/images/Warning.png" alt="" class="" /></span>
          <span *ngFor="let requestType of requestTypes.split(',');let i = index"> {{
            "DASHBOARD."+requestType.trim() | translate
            }} <span *ngIf="i != requestTypes.split(',').length -1">{{ ',' }}</span>
          </span>
          {{"DASHBOARD.NOLONGERACTIVE"
          |
          translate}} {{ cmdfailedDeviceName }} {{ "DASHBOARD.EXMARK" | translate}}
        </div>
      </div>
      <div class="mt-4 mb-3 send-ctrl-request-width border-secondary-subtle">
        <div class="mt-3 settings-security-feature">
          <span> {{ "DASHBOARD.PREVIOUSECMDEXPIRE" | translate }} </span>
        </div>
        <div class="mt-2 settings-security-feature">
          <span> {{ "DASHBOARD.SENDREQUESTTOUSER" | translate }} </span>
        </div>
        <div>
          <button class="mt-3 mb-1 bg-orgclr w-auto submit-btn" (click)="sendCommands()">{{
            "DASHBOARD.SENDAREQUEST" |
            translate }}</button>
        </div>
        <div class="mt-2 settings-security-feature">
          <span><img src="./assets/images/NoteInfoIcon.svg" alt="" class="pb-1" /></span>
          <span> {{ "DASHBOARD.MAKESUREINTERNET" | translate }} </span>
        </div>
      </div>
      <div class="cross-arrow-pos">
        <span (click)="hideSendControlPopup()"><img src="./assets/images/otpCancel.svg" alt="" class="ms-xl-4" /></span>

      </div>
    </div>
  </div>
</div>